import api from "@/api";
import _ from "lodash";
import moment from "moment";
import store from "@/vuex/store";
import { initializeApp } from "firebase/app";
import { getToken } from "firebase/messaging";
import { getMessaging } from "firebase/messaging/sw";
import AWS from "aws-sdk";
import { Auth } from "aws-amplify";
import "nprogress/nprogress.css";
import localStorageService from "@/services/localStorage";
import jwtDecode from "jwt-decode";
import toastr from "toastr";
import { parsePhoneNumber } from "libphonenumber-js";
import { v4 as uuidv4 } from "uuid";

export class Widget {
  mlService;
  languageId = null;
  languageCulture = null;
  allStaticKeys = null;
  allApplangaKeys = null;
  defaultCulture = "en";
  selectedLanguage = null;
  allDynamicKeys = null;
  calLanguages = [
    "af.js",
    "ar.js",
    "bg.js",
    "bs.js",
    "ca.js",
    "cs.js",
    "da.js",
    "de.js",
    "ee.js",
    "el.js",
    "en.js",
    "es.js",
    "fa.js",
    "fi.js",
    "fo.js",
    "fr.js",
    "ge.js",
    "he.js",
    "hr.js",
    "hu.js",
    "id.js",
    "is.js",
    "it.js",
    "ja.js",
    "ko.js",
    "lb.js",
    "lt.js",
    "lv.js",
    "mn.js",
    "nb-NO.js",
    "nl.js",
    "pl.js",
    "pt-BR.js",
    "ro.js",
    "ru.js",
    "sk.js",
    "sl-SI.js",
    "sr-CYRL.js",
    "sr.js",
    "sv.js",
    "th.js",
    "tr.js",
    "uk.js",
    "ur.js",
    "vi.js",
    "zh.js"
  ];

  constructor() {
    this.languageId = localStorageService.getItem("pw-languageId");
    this.selectedLanguage = store.getters.getParticipantsPortalLanguages;
    this.languageCulture = this.selectedLanguage ? this.selectedLanguage.language_culture : "en";
  }

  translate(key, string) {
    const translatedString = this.i18n(key, this.languageCulture);
    return translatedString !== false ? translatedString : string;
  }

  translateToActiveLang(key, defaultText, params = null) {
    let translatedText = this.i18nActivities(key, this.lang);
    if (translatedText) {
      if (!!params && typeof params === "object") {
        Object.keys(params).forEach(paramKey => {
          if (translatedText.indexOf(`[${paramKey}]`) >= 0) {
            translatedText = translatedText.replace(`[${paramKey}]`, params[paramKey]);
          }
        });
      }
      return translatedText;
    }
    return defaultText;
  }

  translateDynamicValues(key, defaultText, params) {
    let translatedText = this.translate(key, defaultText);
    if (translatedText) {
      if(Array.isArray(params)){
        for (let i = 0; i < params.length; i++) {
          if (translatedText.indexOf(`%${i+1}$s`) >= 0) {
            translatedText = translatedText.replace(`%${i+1}$s`, params[i]);
          } else if (translatedText.indexOf(`%${i+1}$d`) >= 0) {
            translatedText = translatedText.replace(`%${i+1}$d`, params[i]);
          } else if (translatedText.indexOf(`%${i+1}$@`) >= 0) {
            translatedText = translatedText.replace(`%${i+1}$d`, params[i]);
          }
        }
      }
      else if (typeof params === "object") {
        Object.keys(params).forEach(paramKey => {
          if (translatedText.indexOf(`[${paramKey}]`) >= 0) {
            translatedText = translatedText.replace(`[${paramKey}]`, params[paramKey]);
          }
        });
      }

      return translatedText;
    }
    return defaultText;
  }

  getCalendarLanguageAvailable() {
    const langStriped = this.languageCulture.includes("-") ? this.languageCulture.split("-")[0] : this.languageCulture;
    if (this.calLanguages.includes(langStriped + ".js") || this.calLanguages.includes(this.languageCulture + ".js")) {
      return this.calLanguages.includes(langStriped + ".js") ? langStriped : this.languageCulture;
    }
    return "en";
  }

  getParticipantsWebTranslation(languageId) {
    return new Promise((resolve, reject) => {
      api
        .getStaticLanguages(languageId)
        .then(response => {
          const mappedStrings = [];
          response.data.forEach(o => {
            mappedStrings[o.resourceKey] = o.resourceValue;
          }, mappedStrings);
          store.dispatch("setParticipantsPortalStrings", mappedStrings);
          this.allStaticKeys = mappedStrings;
          resolve(mappedStrings);
        })
        .catch(e => {
          reject(e);
        });
    });
  }

  getActivityTranslation(studyId, languageCulture) {
    const lang = languageCulture.includes("-") ? languageCulture : languageCulture.toLowerCase();
    const studyIds = localStorageService.getItem("pw-studyId");
    const langID = localStorageService.getItem("pw-languageId");
    return new Promise((resolve, reject) => {
      api
        .getParticipantStudyTranslations(studyIds, langID)
        .then(response => {
          const translations = response.data && response.data[lang] ? response.data[lang].main.entries : [];
          if (response.data && response.data[lang] && lang != undefined) {
            store.dispatch("setParticipantsActivityTranslation", translations);
            this.allDynamicKeys = translations;
          }
          resolve(translations);
        })
        .catch(e => {
          reject(e);
        });
    });
  }

  i18nActivities(key) {
    if (store.getters.getParticipantsActivityTranslation) {
      this.allDynamicKeys = store.getters.getParticipantsActivityTranslation;
      return this.allDynamicKeys[key] ? this.allDynamicKeys[key].v : false;
    }
    return false;
  }

  i18n(key, lang) {
    if (lang && lang.toLowerCase() !== this.defaultCulture) {
      this.languageCulture = lang;
    }

    if (store.getters.getParticipantsPortalLanguageTranslation || this.allStaticKeys !== null) {
      this.strings = store.getters.getParticipantsPortalLanguageTranslation ? store.getters.getParticipantsPortalLanguageTranslation : this.allStaticKeys;
      return this.strings[key] ? this.strings[key] : false;
    }
    if (this.languageCulture !== "" && this.languageCulture !== undefined && this.languageCulture !== "EN" && this.allApplangaKeys !== null) {
      const entries = this.allStaticKeys[this.languageCulture]["main"]["entries"];
      return entries[key] ? entries[key].v : "";
    }
    return false;
  }

  getDynamicStringKey(translationKey, option) {
    let key_displaytext = `${translationKey}_options_${option.id}${"_displaytext"}`;
    let key_formattedBody = `${translationKey}_options_${option.id}${"_formattedBody"}`;
    let key_label = `${translationKey}_options_${option.id}${"_label"}`;
    let dynamicKeys = store.getters.getParticipantsActivityTranslation;
    if (dynamicKeys) {
      if (Object.keys(dynamicKeys).includes(key_displaytext)) {
        return key_displaytext;
      } else if (Object.keys(dynamicKeys).includes(key_formattedBody)) {
        return key_formattedBody;
      } else {
        return key_label;
      }
    } else {
      return key_formattedBody;
    }
  }
}

export class Bitrise {
  bitrise = null;

  constructor() {
    this.bitrise = store.getters.getParticipantsPortalBitriseData;
  }

  getParticipantsPortalSignedHTMLURL(key) {
    return this.bitrise ? (this.bitrise.listOfSignedHTMLURL ? (this.bitrise.listOfSignedHTMLURL[key] ? this.bitrise.listOfSignedHTMLURL[key] : "") : "") : "";
  }

  updateHTMLData(data) {
    if (data && data.listOfSignedHTMLURL) {
      const object = _.cloneDeep(this.bitrise);
      Object.keys(data.listOfSignedHTMLURL).forEach(e => {
        if (Object.keys(object.listOfSignedHTMLURL).includes(e)) {
          object.listOfSignedHTMLURL[e] = data.listOfSignedHTMLURL[e];
        } else {
          object.listOfSignedHTMLURL[e] = data.listOfSignedHTMLURL[e];
        }
      });

      if (data.icons) {
        object["icons"] = data.icons;
      }

      store.dispatch("setParticipantsPortalBitriseData", object);
      this.bitrise = object;
    }
  }

  async getJsonData(key) {
    if (this.bitrise == null) {
      return;
    }
    if (this.bitrise && this.bitrise.listOfSignedJSONURL && this.bitrise.listOfSignedJSONURL[key]) {
      const result = await api.getDataFromURL(this.bitrise.listOfSignedJSONURL[key]);
      return result;
    } else {
      if (key.includes("-strings")) {
        return;
      }
      return "DATA_SYNC_ERROR_MSG";
    }
  }

  getIcon(key) {
    if (this.bitrise == null) {
      return;
    }
    if (this.bitrise && this.bitrise.icons && this.bitrise.icons[key]) {
      return this.bitrise.icons[key];
    } else {
      return;
    }
  }

  getImage(key) {
    if (this.bitrise == null) {
      return;
    }
    if (this.bitrise && this.bitrise.listOfImages && this.bitrise.listOfImages[key]) {
      return this.bitrise.listOfImages[key];
    } else {
      return;
    }
  }

  isHTMLAvailable(key) {
    if (this.bitrise == null) {
      return;
    }
    if (this.bitrise && this.bitrise.listOfSignedHTMLURL && Object.keys(this.bitrise.listOfSignedHTMLURL).includes(key)) {
      return true;
    } else {
      return false;
    }
  }

  getHtmlData(key) {
    if (this.bitrise == null) {
      return;
    }
    if (this.bitrise && this.bitrise.listOfSignedHTMLURL && this.bitrise.listOfSignedHTMLURL[key]) {
      return fetch(this.bitrise.listOfSignedHTMLURL[key])
        .then(function(response) {
          switch (response.status) {
            // status "OK"
            case 200:
              return response.text();
            // status "Not Found"
            case 404:
              throw response;
          }
        })
        .then(function(template) {
          const doc = new DOMParser().parseFromString(template, "text/html");
          return doc;
        });
    } else {
      return "DATA_SYNC_ERROR_MSG";
    }
  }

  getHTML(key) {
    if (this.bitrise == null) {
      return;
    }
    if (this.bitrise && this.bitrise.listOfSignedHTMLURL && this.bitrise.listOfSignedHTMLURL[key]) {
      return fetch(this.bitrise.listOfSignedHTMLURL[key]).then(function(response) {
        switch (response.status) {
          // status "OK"
          case 200:
            return response.text();
          // status "Not Found"
          case 404:
            throw response;
        }
      });
    } else {
      return new Promise((resolve, reject) => {
        reject("DATA_SYNC_ERROR_MSG");
      });
    }
  }

  isAggrementAvailable(key) {
    if (this.bitrise == null) {
      return;
    }
    if (this.bitrise && this.bitrise.listOfSignedAgreementsURL && Object.keys(this.bitrise.listOfSignedAgreementsURL).includes(key)) {
      return true;
    } else {
      return false;
    }
  }
  getAgreementData(key) {
    if (this.bitrise == null) {
      return;
    }
    if (this.bitrise && this.bitrise.listOfSignedAgreementsURL && this.bitrise.listOfSignedAgreementsURL[key]) {
      return fetch(this.bitrise.listOfSignedAgreementsURL[key])
        .then(function(response) {
          switch (response.status) {
            // status "OK"
            case 200:
              return response.text();
            // status "Not Found"
            case 404:
              throw response;
          }
        })
        .then(function(template) {
          const doc = new DOMParser().parseFromString(template, "text/html");
          return doc;
        });
    } else {
      return "DATA_SYNC_ERROR_MSG";
    }
  }

  getTaskAndSchedules() {
    if (this.bitrise == null) {
      return;
    }
    if (this.bitrise) {
      return this.getJsonData("tasks_and_schedules");
    } else {
      return new Promise((resolve, reject) => {
        reject("DATA_SYNC_ERROR_MSG");
      });
    }
  }

  getAgreement() {
    if (this.bitrise == null) {
      return;
    }
    if (this.bitrise) {
      return this.getAgreementData("agreement");
    } else {
      return new Promise((resolve, reject) => {
        reject("DATA_SYNC_ERROR_MSG");
      });
    }
  }

  getSignedPDF(key) {
    if (this.bitrise == null) {
      return;
    }
    if (this.bitrise && this.bitrise.listOfSignedPDFURL && this.bitrise.listOfSignedPDFURL[key]) {
      return fetch(this.bitrise.listOfSignedPDFURL[key]).then(function(response) {
        switch (response.status) {
          case 200:
            return response.url;
          case 404:
            throw response;
        }
      });
    } else {
      return new Promise((resolve, reject) => {
        reject("DATA_SYNC_ERROR_MSG");
      });
    }
  }

  getOnboardingDetails() {
    if (this.bitrise == null) {
      return;
    }
    if (this.bitrise) {
      return this.getAgreementData("study_overview");
    } else {
      return new Promise((resolve, reject) => {
        reject("DATA_SYNC_ERROR_MSG");
      });
    }
  }

  getLicense() {
    if (this.bitrise == null) {
      return;
    }
    if (this.bitrise) {
      return this.getHtmlData("licenseAgreement");
    } else {
      return new Promise((resolve, reject) => {
        reject("DATA_SYNC_ERROR_MSG");
      });
    }
  }

  getPrivacy() {
    if (this.bitrise == null) {
      return;
    }
    if (this.bitrise) {
      return this.getHtmlData("privacy_policy");
    } else {
      return new Promise((resolve, reject) => {
        reject("DATA_SYNC_ERROR_MSG");
      });
    }
  }

  getStudyDetails() {
    if (this.bitrise == null) {
      return;
    }
    if (this.bitrise) {
      return this.getJsonData("study");
    } else {
      return new Promise((resolve, reject) => {
        reject("DATA_SYNC_ERROR_MSG");
      });
    }
  }
}

export class ParticipantPortal {
  keyLanguage = "pw-languageId";
  keyCountry = "pw-countryId";
  keyDefaultLang = "default-languageId";
  keyVersion = "pw-version";
  keyStudyId = "pw-studyId";
  keyStudyName = "pw-studyName";
  keyIsFromWeb = "pw-isFromWeb";
  keyDeviceId = "pw-deviceId";
  keyIsOpenStudy = "pw-isOpenStudy";
  keyOpenEnvEmail = "pw-openEnrollEmail";
  keyVerificationMethod = "pw-verification-method";
  bitrise;
  widget;
  studyDetails = {};

  constructor() {
    this.widget = new Widget();
    this.setParticipantDetails();
  }

  setParticipantDetails() {
    this.studyDetails = {
      version: localStorageService.getItem(this.keyVersion),
      studyId: localStorageService.getItem(this.keyStudyId),
      countryId: localStorageService.getItem(this.keyCountry),
      languageId: localStorageService.getItem(this.keyLanguage),
      deviceId: localStorageService.getItem(this.keyDeviceId),
      awsCognitoAuthentication: localStorageService.getItem("awsCognitoAuthentication"),
      pwebCognitoAuthentication: localStorageService.getItem("pwebCognitoAuthentication")
    };
  }

  changeCognitoPassword(oldPassword, newPassword) {
    const that = this;
    return new Promise(async (resolve, reject) => {
      if ((oldPassword !== "" || oldPassword !== null) && (newPassword !== "" || newPassword !== null)) {
        const AWSconfig = await Auth.configure();
        AWS.config.update({
          region: AWSconfig && AWSconfig.region ? AWSconfig.region : "",
          userPoolId: AWSconfig && AWSconfig.userPoolId ? AWSconfig.userPoolId : "",
          userPoolWebClientId: AWSconfig && AWSconfig.userPoolWebClientId ? AWSconfig.userPoolWebClientId : ""
        });
        const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider();
        const accessToken = localStorageService.getItem("participantAccessToken");
        if (accessToken) {
          cognitoidentityserviceprovider.changePassword(
            {
              AccessToken: accessToken,
              PreviousPassword: oldPassword,
              ProposedPassword: newPassword
            },
            function(err, data) {
              if (err) {
                const error = that.cognitoValidations(err);
                reject(error);
              } else {
                resolve(data);
              }
            }
          );
        } else {
          reject({
            message: this.widget.translate("unable_to_change", "Unable to change password. Please try again later!")
          });
        }
      } else {
        reject({
          message: this.widget.translate("unable_to_change", "Unable to change password. Please try again later!")
        });
      }
    });
  }

  cognitoValidations(err) {
    let error = { message: null };
    switch (err.__type) {
      case "LimitExceededException":
        error.message = this.widget.translate("label_attempt_limit_exceeded", "Attempt limit exceeded, please try after some time.");
        break;
      case "BadRequestException":
        error.message = this.widget.translate("BAD_REQUEST", "Bad Request.");
        break;
      case "DependentServiceFailureException":
        error.message = this.widget.translate("BAD_REQUEST", "Bad Request.");
        break;
      case "InternalFailureException":
        error.message = this.widget.translate("BAD_REQUEST", "Bad Request.");
        break;
      case "NotFoundException":
        error.message = this.widget.translate("BAD_REQUEST", "Bad Request.");
        break;
      case "ResourceNotFoundException":
        error.message = this.widget.translate("BAD_REQUEST", "Bad Request.");
        break;
      case "UnauthorizedException":
        error.message = this.widget.translate("BAD_REQUEST", "Bad Request.");
        break;
      case "UserLambdaValidationException":
        error.message = this.widget.translate("USERNAME_NOT_FOUND", "Username not found.");
        break;
      default:
        error = err;
        break;
    }
    return error;
  }

  isLoggedIn() {
    return !!(store.getters.participant && store.getters.participant.pid !== "");
  }

  isCountryLanguageAvailable() {
    const language = localStorageService.getItem(this.keyLanguage);
    const country = localStorageService.getItem(this.keyCountry);
    const isLanguage = !!(language && (language !== undefined || language !== null || language !== "null"));
    const isCountry = !!(country && (country !== undefined || country !== null || country !== "null"));

    return !!(isLanguage && isCountry);
  }

  isStudyAvailable() {
    const studyId = localStorageService.getItem(this.keyStudyId);
    return !!(studyId && (studyId !== undefined || studyId !== null || studyId !== "null" || studyId !== "0"));
  }

  isLandedFromRecruitmentSite() {
    return !!(this.getVersion() && this.getStudy() && this.getCountry() && this.getLanguage());
  }

  getUserDate() {
    const participant = this.getParticipant();
    const participantTimeZone = moment.tz.guess();
    moment.tz.setDefault(participantTimeZone);

    return participant.startDate == 0 ? moment(participant.registrationDate) : moment(participant.startDate);
  }

  getCurrentDay() {
    const date = this.getUserDate().format("YYYY-MM-DD");

    return moment(new Date()).diff(moment(date), "days");
  }

  getDayFromDate(date) {
    const userDate = this.getUserDate().format("YYYY-MM-DD");
    const compareDate = date ? moment(date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
    return moment(compareDate).diff(moment(userDate), "days");
  }

  isCalendarDateToday(date) {
    const todayDate = moment().format("YYYY-MM-DD");
    return moment(moment(date).format("YYYY-MM-DD")).diff(moment(todayDate), "days") === 0;
  }

  getParticipant() {
    return store.getters.participant;
  }

  getGlobalElements() {
    return store.getters.getParticipantsPortalGlobalElements;
  }

  getStudyDetails() {
    return store.getters.getParticipantsPortalStudyData;
  }

  getCountries() {
    return store.getters.getParticipantCountries;
  }

  getDefaultCountryIso2() {
    let countries = store.getters.getParticipantsPortalStudyData.countryList;
    countries = countries ? (countries.length > 1 ? countries.sort((a, b) => a - b) : countries) : [];
    let defaultCountry = countries.find(item => item.countryId == this.getCountry());
    defaultCountry = defaultCountry || (countries.length > 0 ? countries[0] : null);
    return defaultCountry ? defaultCountry.isoCode2 : "US";
  }

  getLanguages() {
    return store.getters.getParticipantLanguages;
  }

  getCountry() {
    return localStorageService.getItem(this.keyCountry) || this.studyDetails.countryId;
  }

  getLanguage() {
    return localStorageService.getItem(this.keyLanguage) || this.studyDetails.languageId;
  }

  getDevice() {
    return localStorageService.getItem(this.keyDeviceId) || this.studyDetails.deviceId;
  }

  getStudy() {
    return localStorageService.getItem(this.keyStudyId) || this.studyDetails.studyId;
  }

  getVersion() {
    return localStorageService.getItem(this.keyVersion) || this.studyDetails.version;
  }

  getVerificationMethod() {
    return localStorageService.getItem(this.keyVerificationMethod);
  }

  getStudyName() {
    return localStorageService.getItem(this.keyStudyName);
  }

  isFromWeb() {
    return localStorageService.getItem(this.keyIsFromWeb);
  }

  isOpenEnrollmentStudy() {
    const result = localStorageService.getItem(this.keyIsOpenStudy);
    return !!(result && result == "true");
  }

  getLocalStorage(key) {
    return key ? localStorageService.getItem(key) : false;
  }

  setLocalStorage(key, value) {
    if ((key !== null || key !== undefined) && value !== null && value !== undefined) {
      localStorageService.setItem(key, value);
    }
  }

  emptyLocalStorage() {
    localStorageService.removeAll();
  }

  isManualStudyStart() {
    return this.getStudyDetails().isManualStudyStart;
  }

  isParticipantStartToday(startDate) {
    const todayDate = moment().format("YYYY-MM-DD");
    return moment(moment(startDate).format("YYYY-MM-DD")).diff(moment(todayDate), "days") === 0;
  }

  updateUserDetails(object) {
    if (typeof object === "object") {
      const userObj = localStorageService.getItem("userObj");
      const newUserObj = Object.assign(userObj, object);
      localStorageService.setItem("userObj", newUserObj);

      const userData = this.getParticipant();
      const newUserData = Object.assign(userData, object);
      store.dispatch("participantUpdate", newUserData);
    }
  }

  getSiteAddress() {
    const that = this;
    return new Promise((resolve, reject) => {
      const participant = this.getParticipant();
      api.getParticipantAddress(participant.pid).then(
        address => {
          const fullAddress = address.body ? address.body : null;
          fullAddress.country = that.widget.translate("COUNTRY_" + fullAddress.country.toUpperCase().replace(" ", "_"), fullAddress.country);
          if (fullAddress) {
            const completeAddress = that.convertObjectToAddress(fullAddress);
            resolve({
              name: fullAddress.name,
              phone: fullAddress.phoneNumber,
              email: fullAddress.siteEmail,
              type: fullAddress.type,
              address: completeAddress
            });
          } else {
            reject(null);
          }
        },
        () => {
          reject(null);
        }
      );
    });
  }

  /**
   * Convert Address Object formated address
   * @param {*} fullAddress{'address', 'city', 'state', 'zipcode', 'country'}
   * @returns Formated String
   */
  convertObjectToAddress(fullAddress) {
    if (typeof fullAddress === "object") {
      const address = fullAddress.address != null ? fullAddress.address : "";
      const city = fullAddress.city != null ? fullAddress.city : "";
      const state = fullAddress.state != null ? fullAddress.state : "";
      const country = fullAddress.country != null ? fullAddress.country : "";
      const zipcode = fullAddress.zipcode != null ? fullAddress.zipcode : "";
      const completeAddress = (address ? address + (city ? ", " : "") : "") + (city ? city + (state ? ", " : "") : "") + (state ? state + (country ? ", " : "") : "") + (country ? country + (zipcode ? ", " : "") : "") + (zipcode || "");
      return completeAddress.trim();
    } else {
      return null;
    }
  }

  getGlobalElementsObject() {
    const participant = this.getParticipant();
    const studyId = this.getStudy();
    const that = this;
    return new Promise(resolve => {
      const config = new Promise(resolve => {
        that.bitrise = new Bitrise();
        const configObj = that.bitrise.getJsonData("config");
        if (configObj) {
          configObj
            .then(res => {
              resolve(res);
            })
            .catch(() => {
              resolve(false);
            });
        } else {
          resolve(false);
        }
      });

      const logo = new Promise(resolve => {
        that.bitrise = new Bitrise();
        const logoObj = that.bitrise.getImage("logo");
        if (logoObj) {
          resolve(logoObj);
        } else {
          resolve(false);
        }
      });

      const siteDetails = new Promise(resolve => {
        if (participant && participant.pid !== "") {
          api
            .getSiteDetails(participant.pid, { studyId: studyId })
            .then(
              res => {
                resolve(res.data[0]);
              },
              () => {
                resolve(false);
              }
            )
            .catch(() => {
              resolve(false);
            });
        } else {
          resolve(false);
        }
      });

      Promise.all([config, siteDetails, logo]).then(response => {
        const config = response[0];
        const site = response[1];
        const logo = response[2];
        const globalElements = Object.assign(config, {
          site: site,
          studyId: studyId,
          studyLogoUrl: logo
        });

        globalElements["primaryColor"] = globalElements.colorPrimary;
        globalElements["secondaryColor"] = globalElements.colorSecondary;

        if (site) {
          that.updateUserDetails({ siteId: site.siteId });
          api
            .getPrincipalInvestigatorPhone({
              siteId: site.siteId,
              participantId: participant.pid
            })
            .then(
              contact => {
                globalElements["contactNumber"] = contact;
                store.dispatch("setParticipantsGlobalElements", globalElements);
                resolve(true);
              },
              () => {
                store.dispatch("setParticipantsGlobalElements", globalElements);
                resolve(true);
              }
            )
            .catch(() => {
              store.dispatch("setParticipantsGlobalElements", globalElements);
              resolve(true);
            });
        } else {
          store.dispatch("setParticipantsGlobalElements", globalElements);
          resolve(true);
        }
      });
    });
  }
  mapCountry(o) {
    let order = 0;
    const country = {
      active: true,
      countryGroupId: o.countryGroupId,
      countryId: o.country_id,
      countryName: o.name,
      countryType: o.countryType,
      default: o.isoCode2 == "US",
      isoCode2: o.isoCode2,
      isoCode3: o.isoCode3,
      smsCountryCode: "+1",
      smsPhoneNumber: "4698095223",
      sortOrder: order
    };
    order++;
    return country;
  }
  getCountryLanguages() {
    return new Promise((resolve, reject) => {
      if (this.getStudy() && this.getVersion() && this.getCountry() && this.getLanguage()) {
        api
          .getParticipantsWebCountryLanguages(this.getStudy(), this.getVersion())
          .then(res => {
            let order = 0;
            const response = res.data.data;
            const countries = response.countries.map(o => {
              const country = {
                active: true,
                countryGroupId: o.countryGroupId,
                countryId: o.country_id,
                countryName: o.name,
                countryType: o.countryType,
                default: o.isoCode2 == "US",
                isoCode2: o.isoCode2,
                isoCode3: o.isoCode3,
                smsCountryCode: "+1",
                havingOnlyDraftLanguage: o.havingOnlyDraftLanguage,
                smsPhoneNumber: "4698095223",
                sortOrder: order
              };
              order++;
              return country;
            });
            const languages = response.languages;

            store.dispatch("setParticipantCountries", countries);
            store.dispatch("setParticipantLanguages", languages);
            this.getDefaultStaticTranslations();
            this.setLocalStorage("logOut", false);

            resolve(true);
          })
          .catch(error => {
            reject(error);
          });
      } else {
        const countries = new Promise((resolve, reject) => {
          api
            .getCountries()
            .then(response => {
              resolve(response.data);
            })
            .catch(e => {
              reject(e);
            });
        });

        const languages = new Promise((resolve, reject) => {
          api
            .getLanguages()
            .then(response => {
              resolve(response.data);
            })
            .catch(e => {
              reject(e);
            });
        });

        Promise.all([countries, languages])
          .then(response => {
            const countries = response[0];
            const languages = response[1];
            const defaultLang = languages.find(o => o.is_default === true);

            /** Sort Languages in Alphabetic Order */
            languages.sort((a, b) => {
              if (a.display_name < b.display_name) {
                return -1;
              }
              if (a.display_name > b.display_name) {
                return 1;
              }
              return 0;
            });
            /** Sort Languages in Alphabetic Order */

            store.dispatch("setParticipantCountries", countries);
            store.dispatch("setParticipantLanguages", languages);

            this.setLocalStorage("default-languageId", defaultLang.language_id);
            this.getDefaultStaticTranslations();
            this.setLocalStorage("logOut", false);
            resolve(true);
          })
          .catch(error => {
            reject(error);
          });
      }
    });
  }

  getDefaultStaticTranslations() {
    const langId = this.getLanguage();
    const allLanguages = this.getLanguages();
    const selectedLang = allLanguages.find(o => o.language_id == langId);
    if (langId) {
      store.dispatch("setParticipantsPortalLanguages", selectedLang);
      api.getStaticLanguages(langId).then(response => {
        const mappedStrings = [];
        response.data.forEach(o => {
          mappedStrings[o.resourceKey] = o.resourceValue;
        }, mappedStrings);
        store.dispatch("setParticipantsPortalLanguageTranslation", mappedStrings);
      });
    }
  }

  getGlobalElementsData() {
    const studyId = this.getStudy();
    const languageId = this.getLanguage();
    const countryId = this.getCountry();
    const countries = this.getCountries();
    const languages = this.getLanguages();
    return new Promise((resolve, reject) => {
      if (this.isStudyAvailable()) {
        api
          .getParticipantWebGlobalElements(studyId)
          .then(
            response => {
              if (response && response.data.data) {
                const globalElement = response.data.data;
                const selectedLanguage = languages.find(o => o.language_id == languageId);
                const selectedCountry = countries.find(o => o.countryId == countryId);

                if (selectedLanguage) {
                  globalElement.language = selectedLanguage;
                }
                if (selectedCountry) {
                  globalElement.country = selectedCountry;
                }

                if (selectedLanguage && globalElement.language && globalElement.language.language_culture.includes("-") == false) {
                  globalElement.language.language_culture = globalElement.language.language_culture.toLowerCase();
                }

                store.dispatch("setParticipantsGlobalElements", globalElement);
                resolve(studyId);
              } else {
                reject(false);
              }
            },
            error => {
              reject(error);
            }
          )
          .catch(error => {
            reject(error);
          });
      } else {
        reject(false);
      }
    });
  }

  getBitriseDataTranslation() {
    return new Promise((resolve, reject) => {
      const languages = this.getLanguages();
      const language = this.getLanguage();
      this.bitrise = new Bitrise();

      const thisLang = languages.find(o => o.language_id == language);
      if (thisLang && (thisLang.language_culture !== "EN" || thisLang.language_culture !== "en")) {
        const language = thisLang.language_culture.includes("-") ? thisLang.language_culture : thisLang.language_culture == "sv" ? thisLang.language_culture : thisLang.language_culture.toUpperCase();
        const stringObj = this.bitrise.getJsonData(language + "-strings");
        if (stringObj) {
          stringObj
            .then(response => {
              store.dispatch("setParticipantsPortalStrings", response);
              resolve(true);
            })
            .catch(() => {
              reject(false);
            });
        }
      } else {
        reject(false);
      }
    });
  }

  getApplangaTranslations(languageId) {
    return new Promise((resolve, reject) => {
      api
        .getStaticLanguages(languageId)
        .then(response => {
          const mappedStrings = [];
          response.data.forEach(o => {
            mappedStrings[o.resourceKey] = o.resourceValue;
          }, mappedStrings);
          store.dispatch("setParticipantsPortalLanguageTranslation", mappedStrings);
          resolve(mappedStrings);
        })
        .catch(e => {
          reject(e);
        });
    });
  }

  getBitriseData() {
    return new Promise((resolve, reject) => {
      const that = this;
      let params = {};
      const participant = this.getParticipant();
      const joinStudyVersion = this.getVersion();

      if (joinStudyVersion !== "" && joinStudyVersion.includes("-")) {
        params = { versionId: joinStudyVersion };
      } else {
        const studyVersionId = participant && participant.myStudyVersionId ? participant.myStudyVersionId : participant.studyVersionId;
        params = { participantId: participant.pid, versionId: studyVersionId };
      }
      api
        .getParticipantPortalDataFact(this.getStudy(), params)
        .then(response => {
          participant.myStudyVersionId = Object.keys(participant).includes("myStudyVersionId") ? participant.myStudyVersionId : participant.studyVersionId;
          participant.studyVersionId = response.body.versionId;
          store.dispatch("setParticipantsPortalBitriseData", response.body);
          store.dispatch("participantUpdate", participant);

          that.bitrise = new Bitrise();
          const studyDataObj = that.bitrise.getJsonData("study");
          if (studyDataObj) {
            studyDataObj
              .then(res => {
                store.dispatch("setParticipantsPortalStudyData", res);
                localStorageService.setItem("pw-verification-method", res.verificationMethod ? res.verificationMethod : "email");
                resolve(true);
              })
              .catch(error => {
                reject(error);
              });
          } else {
            resolve(true);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  getOpenStudyEligibilityData() {
    return new Promise((resolve, reject) => {
      const that = this;
      that.bitrise = new Bitrise();
      if (this.isOpenEnrollmentStudy()) {
        const studyEligibilityDataObj = that.bitrise.getJsonData("study_eligibility");
        if (studyEligibilityDataObj) {
          studyEligibilityDataObj
            .then(res => {
              resolve(res);
            })
            .catch(() => {
              reject(false);
            });
        } else {
          reject(false);
        }
      }
    });
  }

  cognitoForgotUsername(username) {
    return new Promise((resolve, reject) => {
      Auth.forgotPassword(username, {
        userType: "Participant_Web",
        requestFor: "FORGOT_PASSWORD",
        countryId: this.getCountry(),
        requestFrom: "web"
      }).then(
        res => {
          resolve(res);
        },
        error => {
          let message = null;
          if (error && error.code) {
            switch (error.code) {
              case "LimitExceededException":
                message = this.widget.translate("label_attempt_limit_exceeded", "Attempt limit exceeded, please try after some time.");
                break;
              case "BadRequestException":
                message = this.widget.translate("BAD_REQUEST", "Bad Request.");
                break;
              case "DependentServiceFailureException":
                message = this.widget.translate("BAD_REQUEST", "Bad Request.");
                break;
              case "InternalFailureException":
                message = this.widget.translate("BAD_REQUEST", "Bad Request.");
                break;
              case "NotFoundException":
                message = this.widget.translate("BAD_REQUEST", "Bad Request.");
                break;
              case "ResourceNotFoundException":
                message = this.widget.translate("BAD_REQUEST", "Bad Request.");
                break;
              case "UnauthorizedException":
                message = this.widget.translate("BAD_REQUEST", "Bad Request.");
                break;
              default:
                message = this.widget.translate("ERROR_OCCURED_TRY_LATER", "Error occurred. Try again");
                break;
            }
          } else {
            message = this.widget.translate("ERROR_OCCURED_TRY_LATER", "Error occurred. Try again");
          }
          reject(message);
        }
      );
    });
  }

  cognitoCheckUsername(username) {
    return new Promise((resolve, reject) => {
      api.checkUsernameFact({ username: username }).then(
        res => {
          resolve(res.data);
        },
        error => {
          reject(error);
        }
      );
    });
  }
}

export class Telehealth {
  statusCode = {
    1: "NoAppointments",
    2: "VideoCallNotYetStarted",
    3: "TimeForYourCall",
    4: "Arrived",
    5: "OnCall",
    6: "OnHold",
    7: "LWBS",
    8: "Incomplete",
    9: "Complete",
    10: "Cancelled",
    11: "NoShow",
    12: "JoinCall",
    13: "Initiated"
  };

  visitTypes = {
    telehealth: "Telehealth",
    videocall: "Videocall",
    "in-person": "In-person",
    officevisit: "In-person",
    homevisit: "Homevisit",
    phonecall: "Phonecall"
  };
  currentStatus = 0;
  appointment = {};
  bitrise;

  constructor() {
    this.bitrise = new Bitrise();
  }

  getVideoCallSession() {
    return store.getters.getParticipantTelehealthVideoCallDetails;
  }

  isCallMissed() {
    return !!(this.statusCode[this.currentStatus] == "Cancelled" || this.statusCode[this.currentStatus] == "NoShow");
  }

  isVidoCallSetToday() {
    return this.statusCode[this.currentStatus] == "VideoCallNotYetStarted";
  }

  isTimeForCall() {
    const status = this.statusCode[this.currentStatus] == "TimeForYourCall";
    if (status) {
      return !this.isNotificationExpired(this.appointment);
    } else {
      return false;
    }
  }

  isIncomingCall() {
    return this.statusCode[this.currentStatus] == "JoinCall";
  }

  getParticipant() {
    return store.getters.participant;
  }

  isNotificationExpired(activity) {
    const participant = this.getParticipant();
    if (participant) {
      let participantCurrentDay = 0;
      if (participant.startDate == 0) {
        participantCurrentDay = moment(new Date()).diff(moment(participant.registrationDate), "days");
      } else {
        participantCurrentDay = moment(new Date()).diff(moment(participant.startDate), "days");
      }

      return !(participantCurrentDay >= activity.taskStartDay && participantCurrentDay <= activity.taskEndDay);
    } else {
      return true;
    }
  }

  getVisitType(key) {
    if (key !== null && key !== undefined && key !== "") {
      return Object.keys(this.visitTypes).includes(key.trim()) ? this.visitTypes[key] : "Telehealth";
    } else {
      return null;
    }
  }

  getVisitTypes(visitType) {
    if (visitType != "" || visitType != null) {
      const availableVists = visitType
        .trim()
        .toLowerCase()
        .split("|");
      const availableOptions = {
        videoCall: false,
        officeVisit: false,
        homeVisit: false,
        phoneCall: false
      };
      availableVists.forEach(visit => {
        if (Object.keys(this.visitTypes).includes(visit.trim())) {
          switch (visit.trim()) {
            // case 'telehealth': availableOptions.videoCall = true; availableOptions.officeVisit = true; availableOptions.homeVisit = true; availableOptions.phoneCall = true; break;
            case "videocall":
              availableOptions.videoCall = true;
              break;
            case "telehealth":
              availableOptions.videoCall = true;
              break;
            case "in-person":
              availableOptions.officeVisit = true;
              break;
            case "officevisit":
              availableOptions.officeVisit = true;
              break;
            case "homevisit":
              availableOptions.homeVisit = true;
              break;
            case "phonecall":
              availableOptions.phoneCall = true;
              break;
          }
        }
      });

      return availableOptions;
    } else {
      return null;
    }
  }

  getScheduleVisitTypes(taskId) {
    return new Promise((resolve, reject) => {
      const activityDetailsObj = this.bitrise.getJsonData(taskId);
      if (activityDetailsObj) {
        activityDetailsObj
          .then(response => {
            resolve(response);
          })
          .catch(() => {
            reject("pweb_bitrise_data_problem");
          });
      } else {
        reject("NETWORK_ERROR_MSG");
      }
    });
  }

  getAppointments() {
    const that = this;
    const participant = this.getParticipant();
    return new Promise((resolve, reject) => {
      api
        .getParticipantAppointment({ participantId: participant.pid })
        .then(
          res => {
            that.appointment = res.data;
            resolve(res.data);
          },
          error => {
            reject(error);
          }
        )
        .catch(error => {
          reject(error);
        });
    });
  }

  getVideoCallDetails(pid, appointmentId, offset) {
    return new Promise((resolve, reject) => {
      api
        .startParticipantVideoCall({
          participantId: pid,
          id: appointmentId,
          offset: offset
        })
        .then(
          res => {
            store.dispatch("setParticipantsTelehealthSession", res.data);
            resolve(res.data);
          },
          error => {
            reject(error);
          }
        )
        .catch(error => {
          reject(error);
        });
    });
  }

  setStatus(code) {
    this.currentStatus = code;
  }
}

export class Graph {
  user = store.getters.participant;
  study = store.getters.getParticipantsPortalStudyData;
  today = new Date();

  getUserDay() {
    const userJoinDate = this.user.startDate == 0 ? new Date(this.user.registrationDate) : new Date(this.user.startDate);
    return this._diffDay(userJoinDate.toDateString(), this.today.toDateString());
  }

  getUserEndDay() {
    const userRegDate = new Date(this.user.registrationDate);
    return this._diffDay(userRegDate, this.today);
  }

  getCompletedTime() {
    if (this.study && this.study.studyStartDate) {
      const studyStartDate = new Date(this.study.studyStartDate);
      return this._diffByDays(studyStartDate, this.today);
    } else {
      return { year: 0, month: 0, day: 0, hour: 0, second: 0 };
    }
  }

  getRemainingTime() {
    if (this.study && this.study.studyEndDate) {
      const studyEndDate = new Date(this.study.studyEndDate);
      return this._diffByDays(this.today, studyEndDate);
    } else {
      return { year: 0, month: 0, day: 0, hour: 0, second: 0 };
    }
  }

  _diff(d1, d2) {
    const d1m = moment(d1, this.format);
    const d2m = moment(d2, this.format);
    return {
      year: d2m.diff(d1m, "years"),
      month: d2m.diff(d1m, "months"),
      day: d2m.diff(d1m, "days"),
      hour: d2m.diff(d1m, "hours"),
      second: d2m.diff(d1m, "seconds")
    };
  }

  _diffByDays(d1, d2) {
    const d1m = moment(d1, this.format);
    const d2m = moment().add(this._diffDay(d2, d1), "days");

    const years = d2m.diff(d1m, "year");
    d1m.add(years, "years");

    const months = d2m.diff(d1m, "months");
    d1m.add(months, "months");

    const days = d2m.diff(d1m, "days");
    d1m.add(days, "days");

    const hours = d2m.diff(d1m, "hours");
    d1m.add(hours, "hours");

    const seconds = d2m.diff(d1m, "seconds");
    d1m.add(seconds, "seconds");

    return {
      year: years,
      month: months,
      day: days,
      hour: hours,
      second: seconds
    };
  }

  _diffDay(d1, d2) {
    const date1 = moment(d1);
    const date2 = moment(d2);
    const diffDays = date2.diff(date1, "days");
    return diffDays;
  }
}

export class Activities {
  activities = {};
  schedules = {};
  userDay = null;
  user = store.getters.participant;
  study = store.getters.getParticipantsPortalStudyData;
  today = new Date().getTime();
  dateFormat = "DD MMM YYYY hh:mm A z";
  graph = new Graph();
  portal = new ParticipantPortal();

  constructor(activities, schedules) {
    this.activities = activities || store.getters.getParticipantAdherences;
    this.schedules = schedules || store.getters.getParticipantTaskSchedules;
    this.userDay = this.graph.getUserDay();
  }

  getType() {
    return this.data.type;
  }

  isAllowMultiple(activity) {
    return activity && activity.allowMultiple ? activity.allowMultiple : false;
  }

  isLegacyStudy() {
    if (this.study !== null && this.study !== undefined) {
      return !!(this.study.activityAllowed === false && this.study.activityAllowed !== undefined && Object.keys(this.study).includes("activityAllowed") === false);
    } else {
      return true;
    }
  }

  isOldActivity() {
    return !(this.data && this.data.questions && this.data.rows);
  }

  activitiesIdList() {
    return this.activities.map(o => o.taskId);
  }

  filterActivities() {}

  getScheduledDates() {
    const dates = this.schedules.map(o => o.scheduledDate);
    const minDate = Math.min(dates);
    const maxDate = Math.max(dates);
    const formatedDates = dates.map(o => moment(o.scheduledDate).format(this.dateFormat));
    return {
      min: moment(minDate).format(this.dateFormat),
      max: moment(maxDate).format(this.dateFormat),
      dates: formatedDates
    };
  }

  getScheduledActivities(date) {
    const startDay = this.portal.getDayFromDate(date);
    const adherenceTasks = this.activities;
    const adherenceIds = this.activities.map(o => o.taskId);

    if (this.schedules !== null) {
      const filteredSchedules = this.schedules.filter(o => startDay >= o.startDay && startDay <= o.endDay).filter((v, i, s) => s.findIndex(j => j.taskId + "_" + startDay == v.taskId + "_" + startDay) == i);
      return filteredSchedules.map(o => {
        if (adherenceIds.includes(o.taskId)) {
          const thisActivity = adherenceTasks.find(i => o.taskId === i.taskId);
          o.completedCount = thisActivity.completedCount;
          return o;
        } else {
          o.completedCount = 0;
          return o;
        }
      });
    } else {
      return [];
    }
  }
}

export class Activity {
  data = {};
  study = null;
  widget = new Widget();
  deviceId = null;
  version = null;
  questions = [];
  disabledFields = [];
  updatedDisabledFields = [];
  participant = {};
  globalElements = {};
  languageId = null;
  taskInstanceId = null;
  imagesQuestions = null;
  isBackNavigation = false;
  currentQuestionIndex = null;
  currentQuestionButtonLabel = null;

  constructor(activity, instanceId) {
    this.data = activity;
    this.study = store.getters.getParticipantsPortalStudyData;
    this.version = localStorageService.getItem("pw-version");
    this.deviceId = localStorageService.getItem("pw-deviceId");
    this.languageId = localStorageService.getItem("pw-languageId");
    this.participant = store.getters.participant;
    this.taskInstanceId = instanceId;
    this.globalElements = store.getters.getParticipantsPortalGlobalElements;
  }

  getType() {
    return this.data.type;
  }

  getId() {
    return this.data.activityId;
  }

  isLegacyStudy() {
    if (this.study !== null && this.study !== undefined) {
      return !!(this.study.activityAllowed === false && this.study.activityAllowed !== undefined && Object.keys(this.study).includes("activityAllowed") === false);
    } else {
      return true;
    }
  }

  isOldActivity() {
    return !(this.data && this.data.questions && this.data.rows);
  }

  isAllowedToEdit() {
    return this.data.allowDataEditChecks;
  }

  isScorable() {
    return this.data.canScoreResponses;
  }

  getStepCounts() {
    return this.data.stepsCount;
  }

  setDisabledFields(disabledFields, isBackNavigation, updatedDisabledFields = []) {
    this.disabledFields = disabledFields;
    this.isBackNavigation = isBackNavigation;
    const keys = Object.keys(updatedDisabledFields);
    this.updatedDisabledFields = keys && keys.length > 0 ? updatedDisabledFields : disabledFields;
  }

  setQuestionIndex(index) {
    this.currentQuestionIndex = index;
  }

  getQuestionIndex() {
    const disabledIDs = [];
    const disabledKeys = Object.keys(this.disabledFields);
    for (let x = 0; x < disabledKeys.length; x++) {
      if (this.disabledFields[disabledKeys[x]] == true) {
        disabledIDs.push(disabledKeys[x]);
      }
    }

    /** If Fields are disabled due to Branching Logic */
    if (disabledIDs && disabledIDs.length > 0) {
      /** If Activity is Legacy One */
      if (this.isLegacyStudy() || (this.isLegacyStudy() == false && this.isOldActivity())) {
        if (this.isBackNavigation) {
          for (let x = this.currentQuestionIndex - 1; x >= 0; x--) {
            if (!disabledIDs.includes(this.questions[x].identifier)) {
              this.currentQuestionIndex = x;
              break;
            }
          }
        } else {
          for (let x = this.currentQuestionIndex + 1; x < this.questions.length; x++) {
            if (!disabledIDs.includes(this.questions[x].identifier)) {
              this.currentQuestionIndex = x;
              break;
            }
          }
        }
      } else {
        if (this.isBackNavigation) {
          for (let x = this.currentQuestionIndex - 1; x >= 0; x--) {
            if (this.questions[x].findIndex(o => disabledIDs.includes(o.identifier)) == -1) {
              this.currentQuestionIndex = x;
              break;
            }
          }
        } else {
          for (let x = this.currentQuestionIndex + 1; x < this.questions.length; x++) {
            if (this.questions[x].findIndex(o => disabledIDs.includes(o.identifier)) == -1) {
              this.currentQuestionIndex = x;
              break;
            }
          }
        }
      }
    } else {
      if (this.isBackNavigation) {
        this.currentQuestionIndex--;
      } else {
        this.currentQuestionIndex++;
      }
    }
    return this.currentQuestionIndex !== null ? this.currentQuestionIndex : 0;
  }

  getCurrentQuestionLabel(index) {
    if (index == 0) {
      return this.widget.translate("rsb_get_started", "Start");
    } else if (index == this.questions.length - 1) {
      return this.widget.translate("rsb_submit", "Submit");
    } else {
      return this.widget.translate("next", "Next");
    }
  }

  isActivityLastQuestion(index) {
    return index == this.questions.length - 1;
  }

  /** Update presigned URL's for Question types having images */
  imageQuestionTypes() {
    return ["Image", "SurveyInstruction", "ImageCapture", "MultipleChoice"];
  }

  skipableQuestionTypes() {
    return ["VideoRecording", "AudioRecording", "Measurements", "Index", "Log", "ImageCapture", "Section", "GPSkin", "ValidatedEntry", "SkinAnalyser"];
  }

  filteredQuestions() {
    const skipQuestionTypes = this.skipableQuestionTypes();
    const filterdByQuestionTypes = this.data.questions.filter(o => !(skipQuestionTypes.includes(o.type) || (Object.keys(o).includes("constraints") && o.constraints == null && o.type != "SurveyCompletion")));
    const filteredQuestions = filterdByQuestionTypes.filter(o => (o.constraints ? !skipQuestionTypes.includes(o.constraints.type) : true));
    return _.cloneDeep(filteredQuestions);
  }

  questionsArrayBasedOnRows(rows, questions) {
    return rows
      .map(o => o.map(i => questions.find(q => q.identifier === i)))
      .filter(o => o.filter(i => i !== undefined).length > 0)
      .map(o =>
        o.map(i => {
          i["isAnswered"] = false;
          return i;
        })
      );
  }

  questionsArrayWithoutRows(questions) {
    return questions.map(o => {
      o["isAnswered"] = false;
      return o;
    });
  }

  getReponseArray(questions) {
    if (questions.length > 0) {
      const slectedActivity = store.getters.getParticipantSelectedActivity;
      if (this.isLegacyStudy() || (this.isLegacyStudy() == false && this.isOldActivity())) {
        return {
          studyId: this.study.id,
          surveyId: this.data.identifier,
          participantId: this.participant.pid,
          results: questions.map(this.getQuestionResponse, this).filter(o => o !== null),
          deviceType: "Web",
          uuidFromMobile: uuidv4(),
          deviceId: this.deviceId,
          imageFileNames: [],
          taskInstanceId: this.taskInstanceId,
          studyVersionId: this.participant.myStudyVersionId,
          completionTimeUtc: moment().locale("en").utc().format("YYYY-MM-DD HH:mm:ss"),
          completionTimeLocal: moment().locale("en").format("YYYY-MM-DDTHH:mm:ss.SSSZZ"),
          completionLocalOffset: moment().locale("en").format("Z"),
          activitySchedulingMode: (slectedActivity && slectedActivity.activitySchedulingMode) || "both"
        };
      } else {
        const normalizedQuestions = [];
        for (let i = 0; i < questions.length; i++) {
          for (let j = 0; j < questions[i].length; j++) {
            if (questions[i][j].type !== "SurveyCompletion") {
              normalizedQuestions.push(questions[i][j]);
            }
          }
        }
        return {
          studyId: this.study.id,
          surveyId: this.data.id,
          activityId: this.data.activityId,
          participantId: this.participant.pid,
          results: normalizedQuestions.map(this.getQuestionResponse, this).filter(o => o !== null),
          deviceType: "Web",
          uuidFromMobile: uuidv4(),
          deviceId: this.deviceId,
          imageFileNames: [],
          taskInstanceId: this.taskInstanceId,
          studyVersionId: this.participant.myStudyVersionId,
          completionTimeUtc: moment().locale("en").utc().format("YYYY-MM-DD HH:mm:ss"),
          completionTimeLocal: moment().locale("en").format("YYYY-MM-DDTHH:mm:ss.SSSZZ"),
          completionLocalOffset: moment().locale("en").format("Z"),
          activitySchedulingMode: (slectedActivity && slectedActivity.activitySchedulingMode) || "both"
        };
      }
    } else {
      return [];
    }
  }

  selectedActivity() {
    this.activity = store.getters.getSelectedActivity.data;
    return this.activity;
  }

  translationKeyInitial(question, selectedActivity) {
    return (this.isLegacyStudy() || (this.isLegacyStudy() == false && this.isOldActivity())) ? `${question.guid || question.identifier}` : `${selectedActivity.revisionId || selectedActivity.activityId }_${question.identifier}`;
  }

  prepareActivityResponse(question, merge) {
    let questionAnswers = false;
    const nowDate = new Date();
    const offset = new Date().getTimezoneOffset();
    const { identifier, body, formattedBody, formattedTitle} = question;
    const { type } = question.constraints;
    const selectedActivity = this.selectedActivity();
    const questionTypes = ['boolean', 'dropdown', 'customscale'];
    const translationKeyInitials = this.translationKeyInitial(question, selectedActivity);

    if(question.isAnswered && questionTypes.includes(type.toLowerCase())) {
      const translationKey = this.widget.getDynamicStringKey(translationKeyInitials, {id : merge.optionId});
      questionAnswers = this.widget.i18nActivities(translationKey) ? this.widget.i18nActivities(translationKey) : merge.answerText
    }
    if(question.isAnswered && type.toLowerCase() == "multichoice") {
      let multiChoiceOptionIds = merge.optionId.split(',');
      let multiChoiceAnswers = merge.answerText.split(',');
      questionAnswers = multiChoiceOptionIds.map((option, index) => {
      const translationKey = this.widget.getDynamicStringKey(translationKeyInitials, {id: option});
      return this.widget.i18nActivities(translationKey) ? this.widget.i18nActivities(translationKey) : multiChoiceAnswers[index] }).join(',');
    }
    const o = Math.abs(offset);
    const localTimeOffset = (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
    const siteId = store.getters.participant.siteId;
    const language = this.study.languages.find(o => o.language_id == this.participant.languageId);
    const response = {
      appLanguageId: this.participant.languageId,
      displayLanguage: language.language_culture,
      displayAnswerText: questionAnswers ? questionAnswers : merge.answerText,
      displayQuestionText: this.widget.i18nActivities(`${translationKeyInitials}_formattedBody`) ? this.widget.i18nActivities(`${translationKeyInitials}_formattedBody`) : body,
      questionId: question.identifier,
      hasImageResponse: false,
      questionType: question.constraints.type === "MultiChoice" ? (question.constraints.allowMultiple ? "MultiChoice" : "SingleChoice") : question.constraints.type,
      questionText: question.body,
      isSkipped: question.isSkipped ? question.isSkipped : false,
      timeTaken: 1,
      endTime: question.endTime ? question.endTime.replace("Z", localTimeOffset) : nowDate.toISOString().replace("Z", localTimeOffset),
      startTime: question.startTime ? question.startTime.replace("Z", localTimeOffset) : question.startTime,
      status: question.status,
      siteId: siteId
    };
    if(question && question.constraints && question.constraints.type === "SurveyInstruction") {
      question.formattedTitle = this.getFormattedText(question, language, translationKeyInitials, formattedTitle);
      question.formattedBody = this.getFormattedText(question, language, translationKeyInitials, formattedBody);
    }
    if (question.type == "SurveyInstruction" || question.type.toLowerCase() == "surveyinstruction") {
      response.displayQuestionText = this.getFormattedText(question, language, translationKeyInitials, formattedBody);
      response.questionText = this.getFormattedText(question, language, translationKeyInitials, formattedBody);
      delete response.displayAnswerText;
      delete response.answerText;
    }
    return Object.assign(response, merge);
  }
  getFormattedText(question, language, translationKeyInitials, value) {
    let languageName = language.language_culture.toLowerCase() === "en";
    const translatedFormattedInformation = this.widget.i18nActivities(`${translationKeyInitials}_formattedInformation`) ? this.widget.i18nActivities(`${translationKeyInitials}_formattedInformation`) : question.formattedInformation;
    const translatedFormattedTitle = this.widget.i18nActivities(`${translationKeyInitials}_formattedTitle`) ? this.widget.i18nActivities(`${translationKeyInitials}_formattedTitle`) : question.formattedTitle;
    if (value === undefined || value === "undefined" || value === "") {
      return languageName ? question.formattedInformation : translatedFormattedInformation;
    } else {
      return languageName ? question.formattedTitle : translatedFormattedTitle;
    }
  }

  getQuestionResponse(question) {
    if (question) {
      let mergeOptions = {};
      if ((question.constraints == null || (question.type == "SurveyCompletion" && question.constraints == undefined)) || (this.updatedDisabledFields && this.updatedDisabledFields[question.identifier])) {
        return null;
      }
      switch (question.constraints.type) {
        case "CustomScale":
          if (question.answer && question.answer !== "" && question.answer !== undefined) {
            mergeOptions = { answerText: question.answer, status: "Completed" };
          } else if (question.optional) {
            mergeOptions = { answerText: "", status: "Completed" };
          } else {
            mergeOptions = { answerText: "", status: "Incomplete" };
          }
          return this.prepareActivityResponse(question, mergeOptions);
        case "DateTime":
          let answerText = "";
          let mergeNewOptions = {};
          if (question && question.constraints && question.constraints.subType == "Date") {
            answerText = moment(question.date).locale("en").format("YYYY-MM-DD");
            mergeNewOptions = { date: question.date, status: "Completed" };
          } else if (question && question.constraints && question.constraints.subType == "Time") {
            answerText = moment(question.date).locale("en").format(question.constraints.timeFormat == "12" ? "hh:mm A" : "HH:mm");
            mergeNewOptions = { time: question.time, status: "Completed" };
          } else if (question && question.constraints && question.constraints.subType == "DateTime" && question.hasOwnProperty("time") && !["", "undefined", undefined, "null", null].includes(question.time)) {
            let getTimeFormat = question.constraints.timeFormat == "12";
            let [hours, minutes] = getTimeFormat
              ? question.time
                .substr(0, question.time.length - 2)
                .split(":")
                .map(Number)
              : question.time.split(":").map(Number);
            if (question.time.includes("PM") && hours !== 12) {
              hours += 12;
            }
            answerText = moment(moment(question.date).set({ hour: hours, minute: minutes })).locale("en").format();
            mergeNewOptions = { time: question.time, date: question.date};
            mergeOptions = Object.assign({ answerText: answerText, status: "Completed" }, mergeNewOptions);
          } else if (question.optional) {
            mergeOptions = { answerText: "", time: "", date: "", status: "Completed" };
          } else {
            mergeOptions = { answerText: "", time: "", date: "", status: "Incomplete" };
          }
          return this.prepareActivityResponse(question, mergeOptions);
        case "Date":
          if (question && question.date) {
            answerText = moment(question.date).locale("en").format("YYYY-MM-DD");
            mergeOptions = { answerText: answerText, date: answerText, status: "Completed" };
          } else if (question.optional) {
            mergeOptions = { answerText: "", date: "", status: "Completed" };
          } else {
            mergeOptions = { answerText: "", date: "", status: "Incomplete" };
          }
          return this.prepareActivityResponse(question, mergeOptions);
        case "Time":
          if (question && question.time) {
            mergeOptions = { answerText: question.time, time: question.time, status: "Completed" };
          } else if (question.optional) {
            mergeOptions = { answerText: "", time: "", status: "Completed" };
          } else {
            mergeOptions = { answerText: "", time: "", status: "Incomplete" };
          }
          return this.prepareActivityResponse(question, mergeOptions);
        case "DropDown":
          const option = question.constraints.options.find(o => o.id == question.answer);
          if (question.answer && question.answer !== "" && question.answer !== undefined && (option !== undefined || option !== null) && !!option) {
            mergeOptions = { answerText: option.label, optionId: option.id, status: "Completed" };
          } else if (question.optional) {
            mergeOptions = { answerText: "", optionId: "", status: "Completed" };
          } else {
            mergeOptions = { answerText: "", optionId: "", status: "Incomplete" };
          }
          return this.prepareActivityResponse(question, mergeOptions);
        case "ImageCapture":
          if (question.optionId) {
            mergeOptions = { answerText: question.optionId, status: "Completed" };
          } else if (question.optional) {
            mergeOptions = { answerText: "", status: "Completed" };
          } else {
            mergeOptions = { answerText: "", status: "Incomplete" };
          }
          return this.prepareActivityResponse(question, mergeOptions);
        case "Image":
          let selectedOptions = [];
          if (question.optionsIds) {
            if (question.constraints.languageImageOptions) {
              selectedOptions = question.constraints.languageImageOptions
                .find(o => o.languageCulture.toLowerCase() === "en")
                .options.filter(i => question.optionsIds.includes(i.identifier ? i.identifier : i.id))
                .map(j => {
                  return j.sequence ? j.sequence : j.value;
                });
            } else {
              selectedOptions = question.constraints.options
                .filter(i => question.optionsIds.includes(i.identifier ? i.identifier : i.id))
                .map(j => {
                  return j.sequence ? j.sequence : j.value;
                });
            }

            mergeOptions = { answerText: selectedOptions.join(","), optionId: question.optionsIds.join(","), status: "Completed" };
          } else if (question.optional) {
            mergeOptions = { answerText: "", optionId: "", status: "Completed" };
          } else {
            mergeOptions = { answerText: "", optionId: "", status: "Incomplete" };
          }
          return this.prepareActivityResponse(question, mergeOptions);
        case "Measurements":
          if (question.answer && question.answer !== "" && question.answer !== undefined) {
            mergeOptions = { answerText: question.answer, status: "Completed" };
          } else if (question.optional) {
            mergeOptions = { answerText: "", status: "Completed" };
          } else {
            mergeOptions = { answerText: "", status: "Incomplete" };
          }
          return this.prepareActivityResponse(question, mergeOptions);
        case "Log":
          return this.prepareActivityResponse(question, { answerText: null, status: "Completed" });
        case "MedicationSelector":
          if (question.medication && question.medication.length > 0) {
            mergeOptions = { answerText: JSON.stringify(question.medication).toString(), status: "completed" };
          } else if (question.optional) {
            mergeOptions = { answerText: JSON.stringify([]), status: "Completed" };
          } else {
            mergeOptions = { answerText: JSON.stringify([]), status: "Incomplete" };
          }
          return this.prepareActivityResponse(question, mergeOptions);
        case "MultiChoice":
          if (question.optionsIds) {
            const options = question.constraints.options.filter(o => question.optionsIds.includes(o.id)).map(i => i.label);
            mergeOptions = { answerText: options.join(","), optionId: question.optionsIds.join(","), status: "Completed" };
          } else if (question.options) {
            const options = question.constraints.options.map(i => i.label);
            const optionsIds = question.constraints.options.map(i => i.id);
            mergeOptions = { answerText: options.join(","), optionId: optionsIds.join(","), status: "Completed" };
          } else if (question.optional) {
            mergeOptions = { answerText: "", optionId: "", status: "Completed" };
          } else {
            mergeOptions = { answerText: "", optionId: "", status: "Incomplete" };
          }
          return this.prepareActivityResponse(question, mergeOptions);
        case "Number":
          if (question.answer && question.answer !== "" && question.answer !== undefined) {
            mergeOptions = { answerText: question.answer, status: "Completed" };
          } else if (question.optional) {
            mergeOptions = { answerText: "", status: "Completed" };
          } else {
            mergeOptions = { answerText: "", status: "Incomplete" };
          }
          return this.prepareActivityResponse(question, mergeOptions);
        case "Integer":
          if (question.answer && question.answer !== "" && question.answer !== undefined) {
            mergeOptions = { answerText: question.answer, status: "Completed" };
          } else if (question.optional) {
            mergeOptions = { answerText: "", status: "Completed" };
          } else {
            mergeOptions = { answerText: "", status: "Incomplete" };
          }
          return this.prepareActivityResponse(question, mergeOptions);
        case "Decimal":
          if (question.answer && question.answer !== "" && question.answer !== undefined) {
            mergeOptions = { answerText: question.answer, status: "Completed" };
          } else if (question.optional) {
            mergeOptions = { answerText: "", status: "Completed" };
          } else {
            mergeOptions = { answerText: "", status: "Incomplete" };
          }
          return this.prepareActivityResponse(question, mergeOptions);
        case "NumberScale":
          if (question.answer && question.answer !== "" && question.answer !== undefined) {
            mergeOptions = { answerText: question.answer, status: "Completed" };
          } else if (question.optional) {
            mergeOptions = { answerText: "", status: "Completed" };
          } else {
            mergeOptions = { answerText: "", status: "Incomplete" };
          }
          return this.prepareActivityResponse(question, mergeOptions);
        case "Text":
          if (question.answer && question.answer !== "" && question.answer !== undefined) {
            mergeOptions = { answerText: question.answer, status: "Completed" };
          } else if (question.optional) {
            mergeOptions = { answerText: "", status: "Completed" };
          } else {
            mergeOptions = { answerText: "", status: "Incomplete" };
          }
          return this.prepareActivityResponse(question, mergeOptions);
        case "VAS":
          if (question.answer && question.answer !== "" && question.answer !== undefined) {
            mergeOptions = { answerText: question.answer, status: "Completed" };
          } else if (question.optional) {
            mergeOptions = { answerText: "", status: "Completed" };
          } else {
            mergeOptions = { answerText: "", status: "Incomplete" };
          }
          return this.prepareActivityResponse(question, mergeOptions);
        case "Boolean":
          const answer = question.constraints.options.find(o => o.id == question.optionId);
          if (answer) {
            mergeOptions = { answerText: answer.label, optionId: question.optionId, status: "Completed" };
          } else if (question.optional) {
            mergeOptions = { answerText: "", optionId: "", status: "Completed" };
          } else {
            mergeOptions = { answerText: "", optionId: "", status: "Incomplete" };
          }
          return this.prepareActivityResponse(question, mergeOptions);
        case "GPSkin":
          return this.prepareActivityResponse(question, { answerText: null, status: "Completed" });
        case "Index":
          return this.prepareActivityResponse(question, { answerText: null, status: "Completed" });
        case "ValidatedEntry":
          return this.prepareActivityResponse(question, { answerText: null, status: "Completed" });
        case "WongBaker":
          if (question.answer && question.answer !== "" && question.answer !== undefined) {
            mergeOptions = { answerText: question.answer, status: "Completed" };
          } else if (question.optional) {
            mergeOptions = { answerText: "", status: "Completed" };
          } else {
            mergeOptions = { answerText: "", status: "Incomplete" };
          }
          return this.prepareActivityResponse(question, mergeOptions);
        case "AudioRecording":
          return this.prepareActivityResponse(question, { answerText: null, status: "Completed" });
        case "VideoRecording":
          return this.prepareActivityResponse(question, { answerText: null, status: "Completed" });
        case "SurveyInstruction":
          return this.prepareActivityResponse(question, { answerText: null, status: "Completed" });
      }
    } else {
      return false;
    }
  }

  replaceQuestionImages(questions) {
    if (this.imagesQuestions !== null && this.imagesQuestions !== undefined) {
      const languageId = this.languageId;
      const imageQuestions = this.imagesQuestions
        .map(o => {
          const types = this.imageQuestionTypes();
          if (types.indexOf(o.type) > -1) {
            return o;
          }
        })
        .filter(o => o !== undefined);
      const imageQuestionIds = imageQuestions.map(o => o.identifier);

      if (imageQuestionIds.length == 0) {
        return questions;
      }

      const newQuestions = questions.map(o => {
        if (imageQuestionIds.includes(o.identifier)) {
          const selectedQuestion = imageQuestions.find(q => q.identifier == o.identifier);
          /** Survey Instructions */
          if (selectedQuestion.type == "SurveyInstruction") {
            if (selectedQuestion.imageUrl) {
              o.imageUrl = selectedQuestion.imageUrl;
            }
          }

          /** Image Choice */
          if (selectedQuestion.type == "Image") {
            const langImage = selectedQuestion.languageImageOptions.find(i => i.languageId == languageId);
            if (Object.keys(o).includes("constraints")) {
              o.constraints.languageImageOptions = o.constraints.languageImageOptions.map(k => {
                if (k.languageId == languageId) {
                  k.options = k.options.map(i => {
                    if (langImage !== undefined) {
                      const thisOptions = langImage.options.find(j => j.id == i.id);
                      if (thisOptions !== undefined && selectedQuestion.subType == "Single") {
                        i.imageUrl = thisOptions.imageUrl;
                      }

                      if (thisOptions !== undefined && selectedQuestion.subType == "Multi") {
                        i.imageUrl = thisOptions.imageUrl;
                        i.previewImageUrl = thisOptions.previewImageUrl;
                      }
                    }
                    return i;
                  });
                  return k;
                }
                return k;
              });
            } else {
              o.languageImageOptions = o.languageImageOptions.map(k => {
                if (k.languageId == languageId) {
                  k.options = k.options.map(i => {
                    if (langImage !== undefined) {
                      const thisOptions = langImage.options.find(j => j.id == i.id);
                      if (thisOptions !== undefined && selectedQuestion.subType == "Single") {
                        i.imageUrl = thisOptions.imageUrl;
                      }

                      if (thisOptions !== undefined && selectedQuestion.subType == "Multi") {
                        i.imageUrl = thisOptions.imageUrl;
                        i.previewImageUrl = thisOptions.previewImageUrl;
                      }
                    }
                    return i;
                  });
                  return k;
                }
                return k;
              });
            }
          }

          /** Image Capture */
          if (selectedQuestion.type == "ImageCapture") {
            o.imageUrl = selectedQuestion.imageUrl;
          }

          /** Multi Choice */
          if (selectedQuestion.type == "MultiChoice") {
            o.constraints.bodyImages = o.constraints.bodyImages.map(i => {
              const thisOptions = selectedQuestion.bodyImages.find(j => j.imageId == i.imageId);
              if (thisOptions !== undefined) {
                i.imageUrl = thisOptions.imageUrl;
              }
              return i;
            });
          }

          return o;
        } else {
          return o;
        }
      });
      return newQuestions;
    } else {
      return questions;
    }
  }

  questionsArray() {
    let updatedImageQuestions;
    const rows = this.data && this.data.rows ? _.cloneDeep(this.data.rows) : false;
    const questions = this.filteredQuestions();

    if (this.isLegacyStudy() || (this.isLegacyStudy() == false && this.isOldActivity())) {
      updatedImageQuestions = this.replaceQuestionImages(questions);
      this.questions = this.questionsArrayWithoutRows(updatedImageQuestions);
      return this.questions;
    } else {
      const completionQuestion = this.data.questions.find(o => o.type == "SurveyCompletion");
      const isCompletionRow = completionQuestion == undefined ? false : rows.find(o => o == completionQuestion.identifier);

      if (isCompletionRow == undefined) {
        rows.push([completionQuestion.identifier]);
      }
      updatedImageQuestions = this.replaceQuestionImages(questions);
      this.questions = this.questionsArrayBasedOnRows(rows, updatedImageQuestions);
      return this.questions;
    }
  }
}

export class Branching {
  questions = [];
  disabledFields = [];
  disabledFiledsMap = {};
  isLegacyStudy = false;
  skipToQuestion = null;
  skippedRule = undefined;
  languageId = localStorageService.getItem("pw-languageId");
  user = store.getters.participant;
  study = store.getters.getParticipantsPortalStudyData;
  globalElements = store.getters.getParticipantsPortalGlobalElements;
  questionTypes = ["SurveyInstruction", "CustomScale", "DateTime", "Date", "Time", "DropDown", "ImageCapture", "Image", "Measurements", "Log", "MedicationSelector", "MultiChoice", "Number", "Integer", "Decimal", "NumberScale", "Text", "VAS", "Boolean", "GPSkin", "Index", "ValidatedEntry", "WongBaker", "AudioRecording", "VideoRecording"];
  branchingQuestions = ["CustomScale", "Boolean", "MultiChoice", "DropDown", "Image", "NumberScale", "SurveyInstruction", "Text", "Integer", "Decimal", "Number"];
  recursiveRules = undefined;

  constructor(isLegacyStudy, questions) {
    this.isLegacyStudy = isLegacyStudy;
    this.questions = questions;
  }

  checkLogic(question) {
    this.skippedRule = undefined;
    if (this.branchingQuestions.includes(question.constraints.type) && (question.constraints.type == "Integer" || question.constraints.type == "Decimal" || question.constraints.type == "Number")) {
      this.stepNumber(question);
    } else if (this.branchingQuestions.includes(question.constraints.type) && typeof this[`step${question.constraints.type}`] === "function") {
      const functionName = `step${question.constraints.type}`;
      this[functionName](question);
    }
  }

  selectDisabledFields(currentQuestion, skipToQuestion, status) {
    if (skipToQuestion && skipToQuestion !== "default") {
      if (this.isLegacyStudy) {
        const questionFound = this.questions.find(o => o.identifier == skipToQuestion);
        if (questionFound == undefined) {
          return;
        }
      } else {
        const questionFound = this.questions.find(o => o.find(i => i.identifier == skipToQuestion));
        if (questionFound == undefined) {
          return;
        }
      }
    }

    let matchFound = false;
    if (status == false) {
      const disabledSteps = this.disabledFiledsMap[currentQuestion];
      if (disabledSteps) {
        const that = this;
        disabledSteps.map((o, i) => {
          that.disabledFields[i] = false;
          return false;
        }, that);
        this.disabledFields = disabledSteps.map(() => {
          return false;
        });
      }
    }

    if (skipToQuestion !== null && (skipToQuestion !== "default" || status == false)) {
      if (this.isLegacyStudy) {
        for (let i = 0; i < this.questions.length; i++) {
          const step = this.questions[i];
          if (matchFound == true) {
            if (step.identifier !== skipToQuestion) {
              this.disabledFields[step.identifier] = status;
            } else {
              break;
            }
          }
          if (step.identifier === currentQuestion) {
            matchFound = true;
          }
        }
      } else {
        const questionsToLegacy = [];
        this.questions.forEach(o => {
          o.forEach(i => {
            questionsToLegacy.push(i);
          });
        });

        for (let i = 0; i < questionsToLegacy.length; i++) {
          const step = questionsToLegacy[i];
          if (matchFound == true) {
            if (step.identifier !== skipToQuestion) {
              this.disabledFields[step.identifier] = status;
            } else {
              break;
            }
          }
          if (step.identifier === currentQuestion) {
            matchFound = true;
          }
        }
      }
    }

    if (status == true) {
      this.disabledFiledsMap[currentQuestion] = Object.assign([], this.disabledFields);
    }
  }

  stepCustomScale(question) {
    if (question && question.constraints && question.constraints.rules && question.constraints.rules.length > 0 && question.answer !== undefined && question.answer !== "" && this.checkSkipToForBranching(question.constraints.rules)) {
      let selectedOption = [];
      const { rules, labels } = question.constraints;
      rules.forEach(currentValue => {
        if (currentValue && currentValue.operator == "eq") {
          if (currentValue.singleValue == question.answer.replace(/<\/?[^>]+(>|$)/g, "")) {
            selectedOption.push(currentValue);
          }
        } else if (currentValue && currentValue.operator == "between" && labels && labels.length > 0) {
          const answer = labels.indexOf(question.answer.replace(/<\/?[^>]+(>|$)/g, ""));
          const startValue = labels.indexOf(currentValue.startValue);
          const endValue = labels.indexOf(currentValue.endValue);
          const max = Math.max(startValue, endValue);
          const min = Math.min(startValue, endValue);
          if (answer >= min && answer <= max && selectedOption.length == 0) {
            selectedOption.push(currentValue);
          }
        }
        this.selectDisabledFields(question.identifier, currentValue.skipTo, false);
      });
      if (selectedOption.length > 0) {
        selectedOption.forEach(value => {
          this.skippedRule = selectedOption;
          const skipToQuestion = value ? value.skipTo : null;
          this.selectDisabledFields(question.identifier, skipToQuestion, true);
        });
      }
    }
  }

  stepBoolean(question) {
    if (question.constraints.rules && question.constraints.rules.length > 0 && question.optionId !== undefined && question.optionId !== "" && this.checkSkipToForBranching(question.constraints.rules)) {
      let selectedOption = question.constraints.options.find(o => o.id === question.optionId);
      let selectedRule = question.constraints.rules.find(o => o.value === selectedOption.value);
      question.constraints.rules.forEach((currenValue, index) => {
        if (selectedRule && selectedRule.skipTo !== currenValue.skipTo) {
          this.selectDisabledFields(question.identifier, selectedRule.skipTo, false);
        }
      });
      let skipToQuestion = selectedRule ? selectedRule.skipTo : null;
      this.disabledFields[skipToQuestion] = false;
      if(question.skipped == false){
        this.skippedRule = selectedRule;
        this.selectDisabledFields(question.identifier, skipToQuestion, true);
      }
    }
  }

  stepDropDown(question) {
    if (question.constraints.rules && question.constraints.rules.length > 0 && question.answer !== undefined && question.answer !== "" && this.checkSkipToForBranching(question.constraints.rules)) {
      let selectedOption = question.constraints.options.find(o => o.id === question.answer);
      let selectedRule = question.constraints.rules.find(o => o.value === selectedOption.value);
      question.constraints.rules.forEach((currenValue, index) => {
        if (selectedRule && selectedRule.skipTo !== currenValue.skipTo) {
          this.selectDisabledFields(question.identifier, selectedRule.skipTo, false);
        }
      });
      let skipToQuestion = selectedRule ? selectedRule.skipTo : null;
      if(question.skipped == false){
        this.skippedRule = selectedRule;
        this.selectDisabledFields(question.identifier, skipToQuestion, true);
      }
    }
  }

  stepMultiChoice(question) {
    let isRecursiveBranching = question.recursiveBranching;
    if (question.branchingType === "normal") {
      if (question.constraints.rules && question.constraints.rules.length > 0 && question.optionsIds !== undefined && question.optionsIds.length !== 0 && this.checkSkipToForBranching(question.constraints.rules)) {
        let selectedOptionList = [];
        if (question.constraints.subType == "Single") {
          let selectedOption = question.constraints.options.filter((o, i, a) => question.optionsIds.includes(o.id), question);
          if (selectedOption) {
            selectedOptionList = selectedOption.map(i => {
              return i.value;
            });
          }
          let selectedRule = question.constraints.rules.find(o => selectedOptionList.includes(o.value));
          question.constraints.rules.forEach((currenValue, index) => {
            if (selectedRule && selectedRule.skipTo !== currenValue.skipTo) {
              this.selectDisabledFields(question.identifier, selectedRule.skipTo, false);
            }
          });
          let skipToQuestion = selectedRule ? selectedRule.skipTo : null;
          this.disabledFields[skipToQuestion] = false;
          if(question.skipped == false){
            this.skippedRule = selectedRule;
            this.selectDisabledFields(question.identifier, skipToQuestion, true);
          }
        } else if (question.constraints.subType == "Multi" && !isRecursiveBranching) {
          let selectedOption = question.constraints.options.filter((o, i, a) => question.optionsIds.includes(o.id), question);
          if (selectedOption) {
            selectedOptionList = selectedOption.map(i => {
              return i.value;
            });
          }
          let selectedRule = question.constraints.rules.find(o => selectedOptionList.includes(o.value));
          question.constraints.rules.forEach((currenValue, index) => {
            if (selectedRule && selectedRule.skipTo !== currenValue.skipTo) {
              this.selectDisabledFields(question.identifier, selectedRule.skipTo, false);
            }
          });
          let skipToQuestion = selectedRule ? selectedRule.skipTo : null;
          this.disabledFields[skipToQuestion] = false;
          if(question.skipped == false){
            this.skippedRule = selectedRule;
            this.selectDisabledFields(question.identifier, skipToQuestion, true);
          }
        }
      }
    } else if (question.branchingType === "advance" && question.constraints.subType == "Multi" && question.constraints.branchingConfigured == true) {
      if (question.constraints.recursiveRules && question.constraints.recursiveRules.length > 0 && question.optionsIds !== undefined && question.optionsIds.length !== 0 && this.checkSkipToForBranching(question.constraints.recursiveRules)) {
        let selectedOptionList = [];
        if (isRecursiveBranching === false) {
          let selectedOptionList = [];
          let selectedOption = question.constraints.options.filter(option => {
            return question.optionsIds.includes(option.id);
          });
          if (selectedOption) {
            selectedOptionList = selectedOption.map(i => {
              return i.value;
            });
          }
          let selectedRule = question.constraints.recursiveRules.find(rule => {
            return JSON.stringify(rule.value) === JSON.stringify(selectedOptionList);
          });
          let skipToId = this.skipToAsString(selectedRule);
          question.constraints.recursiveRules.forEach(currenValue => {
            let currentSkipToId = this.skipToAsString(currenValue);
            if ((!!selectedRule && skipToId !== currenValue.skipTo) || question.skipped == true) {
              this.selectDisabledFields(question.identifier, currentSkipToId, false);
            } else if (!selectedRule || question.skipped == true) {
              this.selectDisabledFields(question.identifier, currentSkipToId, false);
            }
          });
          let skipToQuestion = selectedRule ? skipToId : null;
          this.disabledFields[skipToQuestion] = false;
          if (selectedRule) {
            selectedRule.skipTo = skipToId;
          }
          if (question.skipped == false) {
            this.skippedRule = selectedRule;
            this.selectDisabledFields(question.identifier, skipToQuestion, true);
          }
        }
        //Recusrive Branching
        else if (isRecursiveBranching === true) {
          let endRecursiveLoopId = question.recursiveLoopEndQuestionId;
          let combinedNextQuestionIds = []; //get all the next question Ids for selected options
          let selectedOption = question.constraints.options.filter(option => {
            return question.optionsIds.includes(option.id);
          });

          if (selectedOption) {
            selectedOptionList = selectedOption.map(option => {
              return option.value;
            });
          }

          let selectedRule = question.constraints.recursiveRules.filter(rule => selectedOptionList.includes(rule.value[0]));

          selectedRule.map(rule => {
            rule.skipTo.map(el => {
              if (!combinedNextQuestionIds.includes(el)) {
                combinedNextQuestionIds.push(el);
              }
            });
          });

          if (combinedNextQuestionIds.length > 0) {
            combinedNextQuestionIds.push(endRecursiveLoopId);
          }

          if (question.skipped == true || combinedNextQuestionIds.length == 0) {
            question.constraints.recursiveRules.map(rule => {
              if (!!rule && rule.skipTo.length > 0) {
                rule.skipTo.map(id => {
                  this.questions.find(que => {
                    if (que[0].identifier === id) {
                      que[0].skipToQuestionId = undefined;
                      que[0].previousQuestionId = undefined;
                    }
                  });
                });
              }
            });
          }

          if (combinedNextQuestionIds.length > 0 && question.skipped == false) {
            combinedNextQuestionIds.map((id, index) => {
              if (index === 0) {
                question.skipToQuestionId = id;
                this.disabledFields[id] = false;
                this.questions.find(que => {
                  if (que[0].identifier === id) {
                    que[0].skipToQuestionId = combinedNextQuestionIds[index + 1];
                    que[0].previousQuestionId = question.identifier;
                    this.disabledFields[combinedNextQuestionIds[index + 1]] = false;
                  }
                });
              }
              if (index > 0) {
                this.questions.find(que => {
                  if (que[0].identifier === id) {
                    que[0].skipToQuestionId = combinedNextQuestionIds[index + 1];
                    que[0].previousQuestionId = combinedNextQuestionIds[index - 1];
                    this.disabledFields[combinedNextQuestionIds[index + 1]] = false;
                  }
                });
              }
            });
          }
        }
      }
    }
  }

  skipToAsString(rule) {
    let currentSkipToId;
    if (!!rule && Array.isArray(rule.skipTo)) {
      currentSkipToId = rule.skipTo[0];
    } else if (!!rule && typeof rule.skipTo === "string") {
      currentSkipToId = rule.skipTo;
    }
    return currentSkipToId;
  }

  stepImage(question) {
    if (question.constraints.rules && question.constraints.rules.length > 0 && question.optionsIds !== undefined && question.optionsIds.length !== 0 && question.optionsIds[0] && question.optionsIds[0] !== null && this.checkSkipToForBranching(question.constraints.rules)) {
      let selectedOptionList = [];
      if (question.constraints.subType == "Single") {
        let selectedOption = question.constraints.languageImageOptions.find(l => l.languageCulture.toLowerCase() === "en").options.find(o => question.optionsIds.includes(o.id));
        if (selectedOption) {
          selectedOptionList = [selectedOption.value];
        }
        let selectedRule = question.constraints.rules.find(o => selectedOptionList.includes(o.value));
        question.constraints.rules.forEach((currenValue, index) => {
          if (selectedRule && selectedRule.skipTo !== currenValue.skipTo) {
            this.selectDisabledFields(question.identifier, selectedRule.skipTo, false);
          }
        });
        let skipToQuestion = selectedRule ? selectedRule.skipTo : null;
        this.disabledFields[skipToQuestion] = false;
        if(question.skipped == false){
          this.skippedRule = selectedRule;
          this.selectDisabledFields(question.identifier, skipToQuestion, true);
        }
      } else if (question.constraints.subType == "Multi") {
        let selectedOption = question.constraints.languageImageOptions.find(l => l.languageCulture.toLowerCase() === "en").options.filter(o => question.optionsIds.includes(o.id));
        if (selectedOption) {
          selectedOptionList = selectedOption.map(j => {
            return j.value;
          });
        }
        let selectedRule = question.constraints.rules.find(o => selectedOptionList.includes(o.value));
        question.constraints.rules.forEach((currenValue, index) => {
          if (selectedRule && selectedRule.skipTo !== currenValue.skipTo) {
            this.selectDisabledFields(question.identifier, selectedRule.skipTo, false);
          }
        });
        let skipToQuestion = selectedRule ? selectedRule.skipTo : null;
        this.disabledFields[skipToQuestion] = false;
        if(question.skipped == false){
          this.skippedRule = selectedRule;
          this.selectDisabledFields(question.identifier, skipToQuestion, true);
        }
      }
    }
  }

  stepNumberScale(question) {
    if (question.constraints.rules && question.constraints.rules.length > 0 && question.answer !== undefined && question.answer !== "" && this.checkSkipToForBranching(question.constraints.rules)) {
      let selectedOption = [];
      question.constraints.rules.forEach(currentValue => {
        if (currentValue.operator == "eq") {
          if (currentValue.singleValue == question.answer) {
            selectedOption.push(currentValue);
          }
        } else if (currentValue.operator == "between") {
          const max = Math.max(currentValue.startValue, currentValue.endValue);
          const min = Math.min(currentValue.startValue, currentValue.endValue);
          if (question.answer >= min && question.answer <= max) {
            selectedOption.push(currentValue);
          }
        }
        this.selectDisabledFields(question.identifier, currentValue.skipTo, false);
      });
      if (selectedOption.length > 0) {
        selectedOption.forEach(value => {
          const skipToQuestion = value ? value.skipTo : null;
          this.disabledFields[skipToQuestion] = false;
          this.skippedRule = selectedOption;
          this.selectDisabledFields(question.identifier, skipToQuestion, true);
        });
      }
    }
  }

  stepSurveyInstruction(question) {
    if (question.constraints.rules && question.constraints.rules.length > 0 && this.checkSkipToForBranching(question.constraints.rules)) {
      let selectedRule = question.constraints.rules[0];
      let skipToQuestion = selectedRule.skipTo;
      this.skippedRule = selectedRule;
      if (question.constraints.rules[0].operator == "ot") {
        this.selectDisabledFields(question.identifier, skipToQuestion, false);
        this.selectDisabledFields(question.identifier, skipToQuestion, true);
      }
    }
  }

  checkSkipToForBranching(rules) {
    let rulesWithSkipTo = [];
    if (rules) {
      rulesWithSkipTo = rules.filter(rule => {
        return !!rule.skipTo;
      });
    }
    if (!!rulesWithSkipTo && rulesWithSkipTo.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  stepText(question) {
    if (question.constraints.rules && question.constraints.rules.length > 0 && this.checkSkipToForBranching(question.constraints.rules)) {
      let selectedRule = question.constraints.rules[0];
      let skipToQuestion = selectedRule.skipTo;
      this.disabledFields[skipToQuestion] = false;
      if (!question.answer || question.skipped == true) {
        this.selectDisabledFields(question.identifier, skipToQuestion, false);
      }
      if (question.constraints.rules[0].operator == "ot" && question.skipped == false) {
        this.skippedRule = selectedRule;
        this.selectDisabledFields(question.identifier, skipToQuestion, false);
        this.selectDisabledFields(question.identifier, skipToQuestion, true);
      }
    }
  }
  stepNumber(question) {
    if (question.constraints.rules && question.constraints.rules.length > 0 && question.answer !== undefined && question.answer !== "" && this.checkSkipToForBranching(question.constraints.rules)) {
      if (question.constraints.rules[0].operator == "ot") {
        const selectedRule = question.constraints.rules[0];
        const skipToQuestion = selectedRule.skipTo;
        this.disabledFields[skipToQuestion] = false;
        if (!question.answer || question.skipped == true) {
          this.selectDisabledFields(question.identifier, skipToQuestion, false);
        }
        if (question.skipped == false) {
          this.skippedRule = selectedRule;
          this.selectDisabledFields(question.identifier, skipToQuestion, true);
        }
      }
      if (question.constraints.rules[0].operator == "between") {
        const selectedOption = question.constraints.rules.find(o => Number(question.answer) >= Number(o.startValue) && Number(question.answer) <= Number(o.endValue));
        question.constraints.rules.forEach(currenValue => {
          const startValue = Number(currenValue.startValue);
          const endValue = Number(currenValue.endValue);
          if (Number(question.answer) < startValue || Number(question.answer) > endValue) {
            this.selectDisabledFields(question.id, currenValue.skipTo, false);
          }
          if (!selectedOption || !question.answer || question.skipped == true) {
            this.selectDisabledFields(question.identifier, currenValue.skipTo, false);
          }
        });
        const skipToQuestion = selectedOption ? selectedOption.skipTo : null;
        this.disabledFields[skipToQuestion] = false;
        if (question.skipped == false) {
          this.skippedRule = selectedOption;
          this.selectDisabledFields(question.identifier, skipToQuestion, true);
        }
      }
    }
  }
}

export class Validations {
  widget = new Widget();
  question = null;
  user = store.getters.participant;
  study = store.getters.getParticipantsPortalStudyData;
  requiredValidations = {
    minLength: 8,
    minLetter: 1,
    minNumber: 1,
    minSpecial: 1,
    regSpecial: new RegExp("[!@#$%&]", "g"),
    regLetter: new RegExp(/\p{L}/, "gu"),
    regNumber: new RegExp(/\p{N}/, "gu")
  };

  /** Validate Password with various conditions */
  password(password, options) {
    const validation = {
      isValidLetter: false,
      isValidNumber: false,
      isValidSpecial: false,
      isValidLength: false
    };
    if (password === "" || password == null || password == undefined) {
      return {
        isValidLetter: null,
        isValidNumber: null,
        isValidSpecial: null,
        isValidLength: null
      };
    }
    if (options && typeof options === "object") {
      this.requiredValidations = Object.assign(this.requiredValidations, options);
    }

    const lettersLength = (password.match(this.requiredValidations.regLetter) || []).filter((value, index, self) => {
      return self.indexOf(value) == index;
    }).length;
    const numbersLength = (password.match(this.requiredValidations.regNumber) || []).filter((value, index, self) => {
      return self.indexOf(value) == index;
    }).length;
    const specialLength = (password.match(this.requiredValidations.regSpecial) || []).filter((value, index, self) => {
      return self.indexOf(value) == index;
    }).length;

    validation.isValidNumber = this.requiredValidations.regNumber.test(password);
    validation.isValidLetter = this.requiredValidations.regLetter.test(password);
    validation.isValidSpecial = this.requiredValidations.regSpecial.test(password);

    if (this.requiredValidations.minLetter > 0) {
      validation.isValidLetter = lettersLength >= this.requiredValidations.minLetter;
    }

    if (this.requiredValidations.minNumber > 0) {
      validation.isValidNumber = numbersLength >= this.requiredValidations.minNumber;
    }

    if (specialLength >= this.requiredValidations.minSpecial > 0 && specialLength !== 0) {
      validation.isValidSpecial = specialLength >= this.requiredValidations.minSpecial;
    }

    validation.isValidLength = password.length >= this.requiredValidations.minLength;

    return validation;
  }
  /** Validate Password with various conditions */

  /** Validate Unique Username */
  validateUsername(username, options) {
    const validation = {
      isValidLetter: false,
      isValidNumber: false,
      isValidSpecial: false,
      isValidLength: false,
      isValidUnique: false
    };
    if (username == "" || username == undefined || username == null) {
      return {
        isValidLetter: null,
        isValidNumber: null,
        isValidSpecial: null,
        isValidLength: null,
        isValidUnique: null
      };
    }
    if (options && typeof options === "object") {
      this.requiredValidations = Object.assign(this.requiredValidations, options);
    }

    const lettersLength = (username.match(this.requiredValidations.regLetter) || []).filter((value, index, self) => {
      return self.indexOf(value) == index;
    }).length;
    const numbersLength = (username.match(this.requiredValidations.regNumber) || []).filter((value, index, self) => {
      return self.indexOf(value) == index;
    }).length;
    const specialLength = (username.match(this.requiredValidations.regSpecial) || []).filter((value, index, self) => {
      return self.indexOf(value) == index;
    }).length;

    validation.isValidNumber = this.requiredValidations.regNumber.test(username);
    validation.isValidLetter = this.requiredValidations.regLetter.test(username);
    validation.isValidSpecial = this.requiredValidations.regSpecial.test(username);

    if (this.requiredValidations.minLetter > 0) {
      validation.isValidLetter = lettersLength >= this.requiredValidations.minLetter;
    }

    if (this.requiredValidations.minNumber > 0) {
      validation.isValidNumber = numbersLength >= this.requiredValidations.minNumber;
    }

    if (specialLength >= this.requiredValidations.minSpecial && specialLength !== 0) {
      validation.isValidSpecial = specialLength >= this.requiredValidations.minSpecial;
    }

    validation.isValidLength = username.length >= this.requiredValidations.minLength;

    return validation;
  }
  /** Validate Unique Username */

  validate(question) {
    if (question) {
      const type = question && question.constraints ? question.constraints.type : question.type;
      this.question = question;

      switch (type) {
        case "SurveyInstruction":
          return this.instructionScreen();
        case "CustomScale":
          return this.customScale();
        case "DateTime":
          return this.dateTime();
        case "Date":
          return this.date();
        case "Time":
          return this.time();
        case "DropDown":
          return this.dropDown();
        case "ImageCapture":
          return this.imageCapture();
        case "Image":
          return this.imageChoice();
        case "Measurements":
          return this.measurements();
        case "Log":
          return this.log();
        case "MedicationSelector":
          return this.medSelector();
        case "MultiChoice":
          return this.multipleChoice();
        case "Number":
          return this.numberResponse();
        case "Integer":
          return this.numberResponse();
        case "Decimal":
          return this.numberResponse();
        case "NumberScale":
          return this.numberScale();
        case "Text":
          return this.textResponse();
        case "VAS":
          return this.vas();
        case "Boolean":
          return this.boolean();
        case "GPSkin":
          return this.gpSkin();
        case "Index":
          return this.index();
        case "ValidatedEntry":
          return this.validateEntry();
        case "WongBaker":
          return this.wongBaker();
        case "AudioRecording":
          return this.audioRecording();
        case "VideoRecording":
          return this.videoRecording();
        case "SurveyCompletion":
          return this.instructionScreen();
      }
    } else {
      return true;
    }
  }

  validate_time(time) {
    let a = true;
    const groups = /^(\d{2,}):(\d{2}) (AM|PM)$/.exec(time) || /^(\d{2,}):(\d{2})$/.exec(time);
    if (groups && (groups.length == 4 || groups.length == 3)) {
      a = true;
    } else if (Object.keys(time).includes("HH")) {
      if (time.HH == "" || time.mm == "") {
        a = false;
      } else {
        if (isNaN(time.HH) || isNaN(time.mm)) {
          a = false;
        }
        if (time.HH <= 24 && time.mm <= 60) {
        } else {
          a = false;
        }
      }
    } else {
      if (time.hh == "" || time.mm == "") {
        a = false;
      } else {
        if (isNaN(time.hh) || isNaN(time.mm)) {
          a = false;
        }
        if (time.hh <= 12 && time.mm <= 60) {
        } else {
          a = false;
        }
      }
    }
    return a;
  }

  time() {
    if (this.question) {
      if (this.question && this.question.time && this.question.time !== "" && this.validate_time(this.question.time)) {
        return this.getTimeValidations();
      } else {
        return this.widget.translate("error_select_answer", "Please select an answer");
      }
    } else {
      return false;
    }
  }

  videoRecording() {
    return true;
  }

  audioRecording() {
    return true;
  }

  index() {
    return true;
  }

  validateEntry() {
    return true;
  }

  gpSkin() {
    return true;
  }

  boolean() {
    if (this.question) {
      this.question.dataChecks = [];
      if (this.question.dataEditChecks) {
        let fieldErrorText = "";
        let softDataCheck = false;
        for (let k = 0; k < this.question.dataEditChecks.length; k++) {
          if (this.question.dataEditChecks[k].check == "SOFT") {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK" && (this.question.optionId == "" || this.question.optionId == undefined || this.question.optionId == null)) {
              fieldErrorText = "This field is required.";
              toastr.warning(fieldErrorText);

              softDataCheck = true;
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: `This field is required.`
              });
            }
          } else {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK" && (this.question.optionId == "" || this.question.optionId == undefined || this.question.optionId == null)) {
              toastr.error(fieldErrorText);
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }

      if (this.question && this.question.optionId && this.question.optionId !== "") {
        return true;
      } else {
        return this.widget.translate("error_select_answer", "Please select an answer");
      }
    } else {
      return false;
    }
  }

  customScale() {
    if (this.question) {
      if (
        Object.keys(this.question).includes("answer") === false ||
        this.question.answer === undefined ||
        (this.question.constraints && this.question.constraints.labels && Object.values(this.question.constraints.labels).includes(this.question.answer) === false && this.question.constraints.formattedLabels && Object.values(this.question.constraints.formattedLabels).includes(this.question.answer) === false)
      ) {
        return this.widget.translate("error_select_answer", "Please select an answer");
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  date() {
    if (this.question) {
      if (this.question && this.question.date && this.question.date !== "") {
        const date = new Date(this.question.date);
        if (isNaN(date.getTime())) {
          return this.widget.translate("error_select_answer", "Please select an answer");
        } else if (this.question.constraints.showDateRange) {
          if (this.question.constraints.dateRange == "0") {
            return this.validateDateRange();
          } else {
            return this.validateDateDeviation();
          }
        }
        return true;
      } else {
        return this.widget.translate("error_select_answer", "Please select an answer");
      }
    } else {
      return false;
    }
  }

  dateTime() {
    if (this.question) {
      this.question.dataChecks = [];
      if (this.question.dataEditChecks) {
        let fieldErrorText = "";
        let softDataCheck = false;
        for (let k = 0; k < this.question.dataEditChecks.length; k++) {
          if (this.question.dataEditChecks[k].check == "SOFT") {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK" && this.question && this.question.date && this.question.date !== "" && this.question.time && this.question.time !== "") {
              fieldErrorText = "Please fill the dates in the valid format.";
              toastr.warning(fieldErrorText);
              softDataCheck = true;
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: `Please fill the dates in the valid format..`
              });
            }
          } else {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK" && this.question && this.question.date && this.question.date !== "" && this.question.time && this.question.time !== "") {
              return "Please fill the dates in the valid format.";
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }
      if (this.question && this.question.date && this.question.date !== "" && this.question.time && this.question.time !== "" && this.validate_time(this.question.time)) {
        const date = new Date(this.question.date);
        if (isNaN(date.getTime())) {
          return this.widget.translate("error_select_answer", "Please select an answer");
        } else if (this.question.constraints.showDateRange) {
          if (this.question.constraints.dateRange == "0") {
            return this.validateDateRange();
          } else {
            return this.validateDateDeviation();
          }
        } else if (this.question.constraints.showTimeRange) {
          return this.getTimeValidations();
        }
        return true;
      } else {
        return this.widget.translate("error_select_answer", "Please select an answer");
      }
    } else {
      return false;
    }
  }
  validateDateRange() {
    const { startDate, endDate, dateFormat, useStartCurrentDate, useEndCurrentDate } = this.question.constraints;
    let startDateMoment = "";
    let endDateMoment = "";
    let granularity = "";

    if (useStartCurrentDate) {
      startDateMoment = moment()
        .format("DD MMM YYYY")
        .toUpperCase();
    } else {
      startDateMoment = moment(startDate)
        .format("DD MMM YYYY")
        .toUpperCase();
    }
    if (useEndCurrentDate) {
      endDateMoment = moment()
        .format("DD MMM YYYY")
        .toUpperCase();
    } else {
      endDateMoment = moment(endDate)
        .format("DD MMM YYYY")
        .toUpperCase();
    }
    if (dateFormat.includes("d")) {
      granularity = "days";
    } else if (dateFormat.includes("m")) {
      granularity = "month";
    } else if (dateFormat.includes("y")) {
      granularity = "year";
    }
    const date = new Date(this.question.date);
    const answerMoment = moment(date, "DD MMM YYYY");
    if (answerMoment.isBetween(startDateMoment, endDateMoment, granularity, [])) {
      if (this.question.time && this.question.time !== "" && this.validate_time(this.question.time)) {
        return this.getTimeValidations()
      } else {
        return true;
      }
    } else {
      const startDateFormatted = moment(startDateMoment).format(this.getFormattedDate(dateFormat));
      const endDateFormatted = moment(endDateMoment).format(this.getFormattedDate(dateFormat));
      const params = { START_DATE: startDateFormatted, END_DATE: endDateFormatted };
      return this.widget.translateToActiveLang("validation_error_date_range", `Enter a date in the range of ${startDateFormatted} - ${endDateFormatted}.`, params);
    }
  }

  commonTimeCalculations(timeFormat, startTime, endTime) {
    let hoursValues = {};
    let isValidTime = false;
    timeFormat = timeFormat == "12" ? "hh:mm A" : "HH:mm";
    hoursValues = timeFormat == "hh:mm A" ? { hh: moment(this.question.time, timeFormat).format("hh"), mm: moment(this.question.time, timeFormat).format("mm"), A: moment(this.question.time, timeFormat).format("A") } : { HH: moment(this.question.time, timeFormat).format("HH"), mm: moment(this.question.time, timeFormat).format("mm") };

    const startTimeMoment = moment(startTime, timeFormat);
    const endTimeMoment = moment(endTime, timeFormat);
    const time = timeFormat == "hh:mm A" ? `${hoursValues.hh}:${hoursValues.mm} ${hoursValues.A}` : `${hoursValues.HH}:${hoursValues.mm}`;
    const answerMoment = moment(time, timeFormat);
    if (startTimeMoment.isAfter(endTimeMoment)) {
      isValidTime = answerMoment.isBefore(endTimeMoment) || answerMoment.isAfter(startTimeMoment);
    } else {
      isValidTime = answerMoment.isBetween(startTimeMoment, endTimeMoment, "minutes", []);
    }

    if (isValidTime) {
      return true;
    } else {
      const startDateFormatted = startTimeMoment.format(timeFormat);
      const endDateFormatted = endTimeMoment.format(timeFormat);
      const params = { START_DATE: startDateFormatted, END_DATE: endDateFormatted };
      return this.widget.translateToActiveLang("validation_error_time_range", `Enter a time in the range of ${startDateFormatted} - ${endDateFormatted}.`, params);
    }
  }

  validateStartEndTimeRange() {
    const { timeFormat, startTime, endTime } = this.question.constraints;
    return this.commonTimeCalculations(timeFormat, startTime, endTime);
  }
  validateTimeDeviation() {
    const { timeFormat, hoursBefore, hoursAfter } = this.question.constraints;
    const CurrentTimeHoursBefore = moment().subtract(Number(hoursBefore), "hours").valueOf();
    const CurrentTimeHoursAfter = moment().add(Number(hoursAfter), "hours").valueOf();
    const currentTimeBefore = timeFormat == "12" ? moment(new Date(CurrentTimeHoursBefore)).format("hh:mm:A") : moment(new Date(CurrentTimeHoursBefore)).format("HH:mm");
    const currentTimeAfter = timeFormat == "12" ? moment(new Date(CurrentTimeHoursAfter)).format("hh:mm:A") : moment(new Date(CurrentTimeHoursAfter)).format("HH:mm");
    return this.commonTimeCalculations(timeFormat, currentTimeBefore, currentTimeAfter);
  }
  validateDateDeviation() {
    const { dateFormat, daysAfter, daysBefore, targetDate, useTargetCurrentDate } = this.question.constraints;
    const date = new Date(this.question.date);
    const answerMoment = moment(date, "DD MMM YYYY");
    let targetDateMoment = "";

    if (useTargetCurrentDate) {
      targetDateMoment = moment()
        .format("DD MMM YYYY")
        .toUpperCase();
    } else {
      targetDateMoment = moment(targetDate)
        .format("DD MMM YYYY")
        .toUpperCase();
    }
    const startDateMoment = moment(targetDateMoment).subtract(Number(daysBefore), "days");
    const endDateMoment = moment(targetDateMoment).add(Number(daysAfter), "days");
    if (answerMoment.isBetween(startDateMoment, endDateMoment, "days", [])) {
      if (this.question.time && this.question.time !== "" && this.validate_time(this.question.time)) {
        return this.getTimeValidations()
      } else {
        return true;
      }
    } else if (answerMoment.isBefore(startDateMoment, "days")) {
      const startDateFormatted = startDateMoment.format(this.getFormattedDate(dateFormat));
      return this.widget.translateToActiveLang("validation_error_date_start", `Enter a Date that begins ${startDateFormatted} or later.`, { START_DATE: startDateFormatted });
    } else if (answerMoment.isAfter(endDateMoment, "days")) {
      const endDateFormatted = endDateMoment.format(this.getFormattedDate(dateFormat));
      return this.widget.translateToActiveLang("validation_error_date_end", `Enter a Date no later than ${endDateFormatted}.`, { END_DATE: endDateFormatted });
    }
  }
  getTimeValidations() {
    if (this.question.constraints.showTimeRange) {
      if (this.question.constraints.timeRange == "0") {
        return this.validateStartEndTimeRange();
      } else {
        return this.validateTimeDeviation();
      }
    } else {
      return true;
    }
  }
  getFormattedDate(format) {
    switch (format) {
      case "dd/mm/yyyy":
        return "D MMMM YYYY";
      case "mm/dd/yyyy":
        return "MMMM D YYYY";
      case "yyyy/mm/dd":
        return "YYYY MMMM D";
      default:
        return "D MMMM YYYY";
    }
  }

  dropDown() {
    if (this.question) {
      this.question.dataChecks = [];

      if (this.question.dataEditChecks) {
        let fieldErrorText = "";
        let softDataCheck = false;
        for (let k = 0; k < this.question.dataEditChecks.length; k++) {
          if (this.question.dataEditChecks[k].check == "SOFT") {
            // eslint-disable-next-line no-undef
            if (this.question.dataEditChecks[k].type == "NOT_BLANK" && (answer == undefined || answer == "" || this.question.optionId === "")) {
              fieldErrorText = `This field is required.`;
              toastr.warning(fieldErrorText);
              softDataCheck = true;
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: "soft",
                message: fieldErrorText
              });
              return false;
            }
          } else {
            // eslint-disable-next-line no-undef
            if (this.question.dataEditChecks[k].type == "NOT_BLANK" && (answer == "undefined" || answer == "" || this.question.optionId === "")) {
              fieldErrorText = `This field is required.`;
              toastr.error(fieldErrorText);
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }
      if (Object.keys(this.question).includes("answer") === false || this.question.answer === "" || this.question.optionId === "") {
        return this.widget.translate("error_select_answer", "Please select an answer");
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  imageCapture() {
    return true;
  }

  imageChoice() {
    // return true;
    if (this.question) {
      if (this.question && this.question.constraints && this.question.constraints.allowMultiple) {
        return typeof this.question.optionsIds === "object" && this.question.optionsIds.length >= 1 ? true : this.widget.translate("error_select_answer", "Please select an answer");
      } else if (this.question && this.question.optionsIds) {
        return typeof this.question.optionsIds === "object" && this.question.optionsIds.length == 1 && this.question.optionsIds[0] != null ? true : this.widget.translate("error_select_answer", "Please select an answer");
      } else {
        return this.widget.translate("error_select_answer", "Please select an answer");
      }
    } else {
      return false;
    }
  }

  instructionScreen() {
    return true;
  }

  log() {
    return true;
  }

  measurements() {
    if (this.question) {
      this.question.dataChecks = [];

      if (this.question.dataEditChecks) {
        let fieldErrorText = "";
        let softDataCheck = false;
        const numericRegx = /[^a-zA-Z ]+/;
        for (let k = 0; k < this.question.dataEditChecks.length; k++) {
          if (this.question.dataEditChecks[k].check == "SOFT") {
            if (this.question.dataEditChecks[k].type == "DATA_TYPE" && this.question.dataEditChecks[k].value == "DECIMAL" && Number.isInteger(Number(this.question.answer))) {
              fieldErrorText = `Your response is not in the expected format: Decimal. Please review your response.`;
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: fieldErrorText
              });
              softDataCheck = true;
            }
            if (this.question.dataEditChecks[k].type == "DATA_TYPE" && this.question.dataEditChecks[k].value == "Numeric" && !numericRegx.test(this.question.answer)) {
              fieldErrorText = `Your response is not in the expected format: Numeric. Please review your response.`;
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: fieldErrorText
              });
              softDataCheck = true;
            }
            if (this.question.dataEditChecks[k].type == "LESS_THAN" && this.question.dataEditChecks[k].value < this.question.answer) {
              fieldErrorText = `Your response is greater than the expected range ${this.question.dataEditChecks[k].value}. Please review your response.`;
              toastr.warning(fieldErrorText);
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: fieldErrorText
              });
              softDataCheck = true;
            }
            if (this.question.dataEditChecks[k].type == "GREATER_THAN" && this.question.dataEditChecks[k].value > this.question.answer) {
              fieldErrorText = `Your response is less than the expected range ${this.question.dataEditChecks[k].value}. Please review your response.`;
              toastr.warning(fieldErrorText);

              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: fieldErrorText
              });
              softDataCheck = true;
            }
            if (this.question.dataEditChecks[k].type == "DATA_FORMAT") {
              if (!Number.isInteger(Number(this.question.dataEditChecks[k].value))) {
                // allowDecimals = true;
                let validateDecimal;
                const decimal = this.question.dataEditChecks[k].value;
                const answer = this.question.answer;

                if (decimal.includes(".") && answer.includes(".")) {
                  const decimalValue = decimal.split(".");
                  const answerValue = answer.split(".");
                  if (answerValue[0].replace(/\s/g, "").length > decimalValue[0] || !answerValue[0].trim().length) {
                    validateDecimal = false;
                  }
                  if (answerValue[1].replace(/\s/g, "").length > decimalValue[1] || !answerValue[1].trim().length) {
                    validateDecimal = false;
                  }
                } else if (decimal.includes(".")) {
                  validateDecimal = false;
                } else if (answer.length > decimal) {
                  validateDecimal = false;
                } else {
                  validateDecimal = true;
                }

                if (!validateDecimal) {
                  const number = this.question.dataEditChecks[k].value;
                  let message = "";

                  if (number.includes(".")) {
                    const numberValue = number.split(".");
                    for (let i = 1; i <= numberValue[0]; i++) {
                      message += "x";
                    }

                    for (let j = 1; j <= numberValue[1]; j++) {
                      message += "y";
                    }
                  } else {
                    for (let k = 1; k <= number; k++) {
                      message += "x";
                    }
                  }

                  this.hasFieldError = false;
                  this.hasFieldWarning = true;
                  this.fieldErrorText = "";
                  this.fieldWarningText = `Your response is not in the expected format: ${message}. Please review your response.`;
                  this.question.dataChecks.push({
                    dataCheckId: this.question.dataEditChecks[k].id,
                    dataCheckType: this.question.dataEditChecks[k].type,
                    message: this.fieldWarningText
                  });
                  softDataCheck = true;
                }
              } else if (Number.isInteger(Number(this.question.dataEditChecks[k].value))) {
                let validateDecimal = "";
                const decimal = this.question.dataEditChecks[k].value;
                const answer = this.question.answer;

                if (decimal.includes(".") && answer.includes(".")) {
                  const decimalValue = decimal.split(".");
                  const answerValue = answer.split(".");
                  if (answerValue[0].replace(/\s/g, "").length > decimalValue[0] || !answerValue[0].trim().length) {
                    validateDecimal = false;
                  }
                  if (answerValue[1].replace(/\s/g, "").length > decimalValue[1] || !answerValue[1].trim().length) {
                    validateDecimal = false;
                  }
                } else if (decimal.includes(".")) {
                  validateDecimal = false;
                } else if (answer.length > decimal) {
                  validateDecimal = false;
                } else {
                  validateDecimal = true;
                }
                if (!validateDecimal) {
                  const number = this.question.dataEditChecks[k].value;
                  let message = "";

                  if (number.includes(".")) {
                    const numberValue = number.split(".");
                    for (let i = 1; i <= numberValue[0]; i++) {
                      message += "x";
                    }

                    for (let j = 1; j <= numberValue[1]; j++) {
                      message += "y";
                    }
                  } else {
                    for (let k = 1; k <= number; k++) {
                      message += "x";
                    }
                  }
                  this.hasFieldError = false;
                  this.hasFieldWarning = true;
                  this.fieldErrorText = "";
                  this.fieldWarningText = `Your response is not in the expected format: ${message}. Please review your response.`;
                  this.question.dataChecks.push({
                    dataCheckId: this.question.dataEditChecks[k].id,
                    dataCheckType: this.question.dataEditChecks[k].type,
                    message: this.fieldWarningText
                  });
                  softDataCheck = true;
                }
              }
            }
          } else {
            if (this.question.dataEditChecks[k].type == "DATA_TYPE" && this.question.dataEditChecks[k].value == "Numeric" && !Number.isInteger(Number(this.question.answer))) {
              return `Please enter a response with format: Numeric.`;
            } else if (this.question.dataEditChecks[k].type == "DATA_TYPE" && this.question.dataEditChecks[k].value == "DECIMAL" && Number.isInteger(Number(this.question.answer))) {
              return `Please enter a response with format: Decimal.`;
            } else if (this.question.dataEditChecks[k].type == "GREATER_THAN" && this.question.dataEditChecks[k].value > this.question.answer) {
              return `Please enter a response greater than ${this.question.dataEditChecks[k].value}.`;
            } else if (this.question.dataEditChecks[k].type == "LESS_THAN" && this.question.dataEditChecks[k].value < this.question.answer) {
              return `Please enter a response less than ${this.question.dataEditChecks[k].value}.`;
            } else if (this.question.dataEditChecks[k].type == "DATA_FORMAT") {
              if (!Number.isInteger(Number(this.question.dataEditChecks[k].value))) {
                let validateDecimal;
                const decimal = this.question.dataEditChecks[k].value;
                const answer = this.question.answer;

                if (decimal.includes(".") && answer.includes(".")) {
                  const decimalValue = decimal.split(".");
                  const answerValue = answer.split(".");
                  if (answerValue[0].replace(/\s/g, "").length > decimalValue[0] || !answerValue[0].trim().length) {
                    validateDecimal = false;
                  }
                  if (answerValue[1].replace(/\s/g, "").length > decimalValue[1] || !answerValue[1].trim().length) {
                    validateDecimal = false;
                  }
                } else if (decimal.includes(".")) {
                  validateDecimal = false;
                } else if (answer.length > decimal) {
                  validateDecimal = false;
                } else {
                  validateDecimal = true;
                }
                if (!validateDecimal) {
                  const number = this.question.dataEditChecks[k].value;
                  let message = "";

                  if (number.includes(".")) {
                    const numberValue = number.split(".");
                    for (let i = 1; i <= numberValue[0]; i++) {
                      message += "x";
                    }

                    for (let j = 1; j <= numberValue[1]; j++) {
                      message += "y";
                    }
                  } else {
                    for (let k = 1; k <= number; k++) {
                      message += "x";
                    }
                  }
                  this.hasFieldError = true;
                  this.fieldErrorText = `Please enter a response using format: ${message}.`;
                }
              } else if (Number.isInteger(Number(this.question.dataEditChecks[k].value))) {
                let validateDecimal;
                const decimal = this.question.dataEditChecks[k].value;
                const answer = this.question.answer;

                if (decimal.includes(".") && answer.includes(".")) {
                  const decimalValue = decimal.split(".");
                  const answerValue = answer.split(".");
                  if (answerValue[0].replace(/\s/g, "").length > decimalValue[0] || !answerValue[0].trim().length) {
                    validateDecimal = false;
                  }
                  if (answerValue[1].replace(/\s/g, "").length > decimalValue[1] || !answerValue[1].trim().length) {
                    validateDecimal = false;
                  }
                } else if (decimal.includes(".")) {
                  validateDecimal = false;
                } else if (answer.length > decimal) {
                  validateDecimal = false;
                } else {
                  validateDecimal = true;
                }
                if (!validateDecimal) {
                  const number = this.question.dataEditChecks[k].value;
                  let message = "";

                  if (number.includes(".")) {
                    const numberValue = number.split(".");
                    for (let i = 1; i <= numberValue[0]; i++) {
                      message += "x";
                    }

                    for (let j = 1; j <= numberValue[1]; j++) {
                      message += "y";
                    }
                  } else {
                    for (let k = 1; k <= number; k++) {
                      message += "x";
                    }
                  }

                  this.hasFieldError = true;
                  this.fieldErrorText = `Please enter a response using format: ${message}.`;
                }
              }
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }
    } else {
      return false;
    }
  }

  medSelector() {
    if (this.question && this.question.medication) {
      this.question.dataChecks = [];
      if (this.question.dataEditChecks) {
        let fieldErrorText = "";
        let softDataCheck = false;
        for (let k = 0; k < this.question.dataEditChecks.length; k++) {
          if (this.question.dataEditChecks[k].check == "SOFT") {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK") {
              this.question.isSkippable = true;
              this.errorIndex.length = 0;
              if (this.updatedAns) {
                this.updatedAns.forEach(elem => {
                  if (elem.listImages.length === 0 && (elem.medicationDosage === "" || typeof elem.medicationDosage === "undefined")) {
                    softDataCheck = true;
                    fieldErrorText = "This field is required.";
                    toastr.warning(fieldErrorText);
                  }
                });
              }
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: `This field is required.`
              });
            }
          } else {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK") {
              this.errorIndex.length = 0;
              if (this.updatedAns) {
                this.updatedAns.forEach(elem => {
                  if (elem.listImages.length === 0 && (elem.medicationDosage === "" || typeof elem.medicationDosage === "undefined")) {
                    return "This field is required.";
                  }
                });
              }
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }
      const medication = this.question.medication;
      let response = true;

      medication.forEach(e => {
        if (typeof e.listImages !== "object") {
          response = false;
        }

        if (!e.isNonCSV && (typeof e.medicationType !== "string" || e.medicationType == "")) {
          response = "Medication name is required.";
        } else if (typeof e.medicationName !== "string" || e.medicationName == "") {
          response = "Medication name is required.";
        } else if (!e.isOtherSelected && !e.isNonCSV && (typeof e.medicationDosage !== "string" || e.medicationDosage == "" || e.medicationDosage == "/" || e.medicationDosage == ".")) {
          response = "Medication dosage amount, such as 250, is required.";
        } else if ((e.isNonCSV || e.isOtherSelected) && (typeof e.medicationDosage !== "string" || e.medicationDosage == "" || e.medicationDosage == "/" || e.medicationDosage == ".")) {
          response = "Medication dosage amount, such as 250, is required.";
        } else if ((e.isNonCSV || e.isOtherSelected) && !e.isNewActivity && e.dosageUnits == "") {
          response = "Medication dosage unit is required.";
        } else if ((e.isNonCSV || e.isOtherSelected) && e.isNewActivity && this.question.constraints.dosageUnits && this.question.constraints.dosageUnits.length && e.dosageUnits == "") {
          response = "Medication dosage unit is required.";
        } else if ((e.isNonCSV || e.isOtherSelected) && e.isNewActivity && !this.question.constraints.dosageUnits.length && e.dosageUnits == "") {
          response = "Medication dosage unit is required.";
        } else if (e.numberOfDoses == "") {
          response = "Number of doses is required.";
        } else if (e.numberOfDoses <= 0) {
          response = "Number of doses should be greater than 0.";
        } else if (e.numberOfDoses.length > 2) {
          const answerValue = e.numberOfDoses.split(".");
          if (answerValue[0].replace(/\s/g, "").length > 2) {
            response = "Number of doses should be less than 3 digits.";
          }
        } else if (this.question.constraints.reasons && this.question.constraints.reasons.length && e.reasons == "") {
          response = "Reason for use required.";
        }
      });
      return response;
    } else {
      return "Medication name is required.";
    }
  }

  multipleChoice() {
    if (this.question) {
      if (this.question && this.question.optionsIds && this.question.constraints.subType == "Single") {
        return typeof this.question.optionsIds === "object" && this.question.optionsIds.length == 1 ? true : this.widget.translate("error_select_answer", "Please select an answer");
      } else if (this.question && this.question.optionsIds && this.question.constraints.subType == "Multi") {
        return typeof this.question.optionsIds === "object" && (this.question.optionsIds.length == 0 || !this.question.optionsIds[0]) ? this.widget.translate("error_select_answer", "Please select an answer") : true;
      } else {
        return this.widget.translate("error_select_answer", "Please select an answer");
      }
    } else {
      return false;
    }
  }

  numberResponse() {
    if (this.question) {
      this.question.dataChecks = [];
      if (this.question.dataEditChecks) {
        let fieldErrorText = "";
        let softDataCheck = false;
        for (let k = 0; k < this.question.dataEditChecks.length; k++) {
          if (this.question.dataEditChecks[k].check == "SOFT") {
            if (this.question.dataEditChecks[k].type == "DATA_TYPE" && this.question.dataEditChecks[k].value == "Numeric" && !Number.isInteger(Number(this.question.answer))) {
              fieldErrorText = `Your response is not in the expected format: Numeric. Please review your response.`;
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: fieldErrorText
              });
              softDataCheck = true;
            }
            if (this.question.dataEditChecks[k].type == "DATA_FORMAT") {
              if (!Number.isInteger(Number(this.question.dataEditChecks[k].value))) {
                let validateDecimal;
                const decimal = this.question.dataEditChecks[k].value;
                const answer = this.question.answer;

                if (decimal.includes(".") && answer.includes(".")) {
                  const decimalValue = decimal.split(".");
                  const answerValue = answer.split(".");
                  if (answerValue[0].replace(/\s/g, "").length > decimalValue[0] || !answerValue[0].trim().length) {
                    validateDecimal = false;
                  }
                  if (answerValue[1].replace(/\s/g, "").length > decimalValue[1] || !answerValue[1].trim().length) {
                    validateDecimal = false;
                  }
                } else if (decimal.includes(".")) {
                  validateDecimal = false;
                } else if (!!answer && answer.length > decimal) {
                  validateDecimal = false;
                } else {
                  validateDecimal = true;
                }

                if (!validateDecimal) {
                  const number = this.question.dataEditChecks[k].value;
                  let message = "";

                  if (number.includes(".")) {
                    const numberValue = number.split(".");
                    for (let i = 1; i <= numberValue[0]; i++) {
                      message += "x";
                    }

                    for (let j = 1; j <= numberValue[1]; j++) {
                      message += "y";
                    }
                  } else {
                    for (let k = 1; k <= number; k++) {
                      message += "x";
                    }
                  }

                  this.hasFieldError = false;
                  this.hasFieldWarning = true;
                  this.fieldErrorText = "";
                  this.fieldWarningText = `Your response is not in the expected format: ${message}. Please review your response.`;
                  this.question.dataChecks.push({
                    dataCheckId: this.question.dataEditChecks[k].id,
                    dataCheckType: this.question.dataEditChecks[k].type,
                    message: this.fieldWarningText
                  });
                  softDataCheck = true;
                }
              } else if (Number.isInteger(Number(this.question.dataEditChecks[k].value))) {
                let validateDecimal = "";
                const decimal = this.question.dataEditChecks[k].value;
                const answer = this.question.answer;

                if (decimal.includes(".") && answer.includes(".")) {
                  const decimalValue = decimal.split(".");
                  const answerValue = answer.split(".");
                  if (answerValue[0].replace(/\s/g, "").length > decimalValue[0] || !answerValue[0].trim().length) {
                    validateDecimal = false;
                  }
                  if (answerValue[1].replace(/\s/g, "").length > decimalValue[1] || !answerValue[1].trim().length) {
                    validateDecimal = false;
                  }
                } else if (decimal.includes(".")) {
                  validateDecimal = false;
                } else if (!!answer && answer.length > decimal) {
                  validateDecimal = false;
                } else {
                  validateDecimal = true;
                }
                if (!validateDecimal) {
                  const number = this.question.dataEditChecks[k].value;
                  let message = "";

                  if (number.includes(".")) {
                    const numberValue = number.split(".");
                    for (let i = 1; i <= numberValue[0]; i++) {
                      message += "x";
                    }

                    for (let j = 1; j <= numberValue[1]; j++) {
                      message += "y";
                    }
                  } else {
                    for (let i = 1; i <= number; i++) {
                      message += "x";
                    }
                  }
                  this.hasFieldError = false;
                  this.hasFieldWarning = true;
                  this.fieldErrorText = "";
                  this.fieldWarningText = `Your response is not in the expected format: ${message}. Please review your response.`;
                  this.question.dataChecks.push({
                    dataCheckId: this.question.dataEditChecks[k].id,
                    dataCheckType: this.question.dataEditChecks[k].type,
                    message: this.fieldWarningText
                  });
                  softDataCheck = true;
                }
              }
            }
          } else {
            if (this.question.dataEditChecks[k].type == "DATA_TYPE" && this.question.dataEditChecks[k].value == "Numeric" && !Number.isInteger(Number(this.question.answer))) {
              return `Please enter a response with format: Numeric.`;
            } else if (this.question.dataEditChecks[k].type == "DATA_FORMAT") {
              if (!Number.isInteger(Number(this.question.dataEditChecks[k].value))) {
                let validateDecimal;
                const decimal = this.question.dataEditChecks[k].value;
                const answer = this.question.answer;

                if (decimal.includes(".") && answer.includes(".")) {
                  const decimalValue = decimal.split(".");
                  const answerValue = answer.split(".");
                  if (answerValue[0].replace(/\s/g, "").length > decimalValue[0] || !answerValue[0].trim().length) {
                    validateDecimal = false;
                  }
                  if (answerValue[1].replace(/\s/g, "").length > decimalValue[1] || !answerValue[1].trim().length) {
                    validateDecimal = false;
                  }
                } else if (decimal.includes(".")) {
                  validateDecimal = false;
                } else if (!!answer && answer.length > decimal) {
                  validateDecimal = false;
                } else {
                  validateDecimal = true;
                }
                if (!validateDecimal) {
                  const number = this.question.dataEditChecks[k].value;
                  let message = "";

                  if (number.includes(".")) {
                    const numberValue = number.split(".");
                    for (let i = 1; i <= numberValue[0]; i++) {
                      message += "x";
                    }

                    for (let j = 1; j <= numberValue[1]; j++) {
                      message += "y";
                    }
                  } else {
                    for (let k = 1; k <= number; k++) {
                      message += "x";
                    }
                  }
                  this.hasFieldError = true;
                  this.fieldErrorText = `Please enter a response using format: ${message}.`;
                }
              } else if (Number.isInteger(Number(this.question.dataEditChecks[k].value))) {
                let validateDecimal;
                const decimal = this.question.dataEditChecks[k].value;
                const answer = this.question.answer;

                if (decimal.includes(".") && answer.includes(".")) {
                  const decimalValue = decimal.split(".");
                  const answerValue = answer.split(".");
                  if (answerValue[0].replace(/\s/g, "").length > decimalValue[0] || !answerValue[0].trim().length) {
                    validateDecimal = false;
                  }
                  if (answerValue[1].replace(/\s/g, "").length > decimalValue[1] || !answerValue[1].trim().length) {
                    validateDecimal = false;
                  }
                } else if (decimal.includes(".")) {
                  validateDecimal = false;
                } else if (!!answer && answer.length > decimal) {
                  validateDecimal = false;
                } else {
                  validateDecimal = true;
                }
                if (!validateDecimal) {
                  const number = this.question.dataEditChecks[k].value;
                  let message = "";

                  if (number.includes(".")) {
                    const numberValue = number.split(".");
                    for (let i = 1; i <= numberValue[0]; i++) {
                      message += "x";
                    }

                    for (let j = 1; j <= numberValue[1]; j++) {
                      message += "y";
                    }
                  } else {
                    for (let k = 1; k <= number; k++) {
                      message += "x";
                    }
                  }

                  this.hasFieldError = true;
                  this.fieldErrorText = `Please enter a response using format: ${message}.`;
                }
              }
            }
          }
        }
        if (softDataCheck && !!fieldErrorText) {
          toastr.warning(fieldErrorText);
          return false;
        }
      }

      if (Object.keys(this.question).includes("answer") === false) {
        return this.widget.translate("error_select_answer", "Please select an answer");
      } else {
        if ((this.question.constraints.allowNegative === false) && (this.question.answer < this.question.constraints.minValue)) {
          if (this.question.constraints.hasSoftMinMax) {
            if (this.question.answer >= this.question.constraints.softminValue) {
              this.hasFieldWarning = true;
              this.hasFieldWarning = this.widget.translateDynamicValues("validation_error_number_soft_min", `This value is less than min (${this.question.constraints.minValue}) but greater than or equal to soft min (${this.question.constraints.softminValue}).`, { "MIN_NUM": this.question.constraints.minValue, "SOFT_MIN_NUM": this.question.constraints.softminValue });
              toastr.warning(this.hasFieldWarning);
              return true;
            }
          }

          let errMsg;
          if (this.question.constraints.hasMinMax && this.question.constraints["minValue"] !== undefined && this.question.constraints["maxValue"] !== undefined) {
            errMsg = this.widget.translateDynamicValues("rsb_invalid_answer_integer_in_between", `Please enter a number that is between ${this.question.constraints.minValue} (Min) and ${this.question.constraints.maxValue} (Max).`, [this.question.constraints.minValue, this.question.constraints.maxValue]);
          } else {
            errMsg = this.widget.translateDynamicValues("rsb_invalid_answer_integer_under", `Please enter a number that is greater than ${this.question.constraints.minValue}.`, [this.question.constraints.minValue]);
          }
          return errMsg;
        }

        if (this.question.answer > this.question.constraints.maxValue) {
          if (this.question.answer <= this.question.constraints.softmaxValue) {
            this.hasFieldWarning = true;
            this.hasFieldWarning = this.widget.translateDynamicValues("validation_error_number_soft_max", `This value is greater than max (${this.question.constraints.maxValue}) but less than or equal to soft max (${this.question.constraints.softmaxValue}).`, { "MAX_NUM": this.question.constraints.maxValue, "SOFT_MAX_NUM": this.question.constraints.softmaxValue });
            toastr.warning(this.hasFieldWarning);
            return true;
          }
          
          let errMsg;
          if (this.question.constraints.hasMinMax && this.question.constraints["minValue"] !== undefined && this.question.constraints["maxValue"] !== undefined) {
            errMsg = this.widget.translateDynamicValues("rsb_invalid_answer_integer_in_between", `Please enter a number that is between ${this.question.constraints.minValue} (Min) and ${this.question.constraints.maxValue} (Max).`, [this.question.constraints.minValue, this.question.constraints.maxValue]);
          } else {
            errMsg = this.widget.translateDynamicValues("rsb_invalid_answer_integer_under", `Please enter a number that is less than ${this.question.constraints.maxValue}.`, [this.question.constraints.maxValue]);
          }
          return errMsg;
        }

        // if (this.question.constraints.allowDecimals === false && Math.floor(this.question.answer) !== this.question.answer) {
        //     return `Decimals not allowed`;
        // }

        let charCode = this.question.answer.toString();
        if (charCode.includes(".")) {
            var numb = charCode.split(".")[1];
            if (numb != null && numb.length > this.question.constraints.decimalValue) {
                this.hasFieldError = true;
                let errMsg = this.widget.translateDynamicValues("rsb_invalid_decimal_place_under", `Up to ${this.question.constraints.decimalValue} decimals are allowed.`, [this.question.constraints.decimalValue]);
                this.fieldErrorText = errMsg;
                toastr.warning(this.hasFieldWarning);
                return errMsg;
            }
            if (numb != null && !this.question.constraints.decimalValue) {
                this.hasFieldError = true;
                let errMsg = this.widget.translate("validation_error_decimal_not_allow", `Decimals not allowed`);
                this.fieldErrorText = errMsg;
                toastr.warning(this.hasFieldWarning);
                return errMsg;
            }
        }

        if (this.question.constraints.allowNegative === false && this.question.answer < 0) {
          return this.widget.translate("validation_error_negative_number", `Negative value not allowed`);
        }

        if (isNaN(Number(this.question.answer))) {
          return this.widget.translate("validation_error_valid_number", `Answer should be a valid number`);
        }

        return true;
      }
    } else {
      return false;
    }
  }

  numberScale() {
    if (this.question) {
      this.question.dataChecks = [];
      if (this.question.dataEditChecks) {
        let fieldErrorText = "";
        let softDataCheck = false;
        for (let k = 0; k < this.question.dataEditChecks.length; k++) {
          if (this.question.dataEditChecks[k].check == "SOFT") {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK" && (this.question.answer === "undefined" || this.question.answer === "")) {
              fieldErrorText = `This field prefered to be filled.`;
              toastr.warning(fieldErrorText);

              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: fieldErrorText
              });
              softDataCheck = true;
            }
            if (this.question.dataEditChecks[k].type == "LESS_THAN" && this.question.dataEditChecks[k].value < this.question.answer) {
              fieldErrorText = `This field should be less than ${this.question.dataEditChecks[k].value}.`;
              toastr.warning(fieldErrorText);
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: fieldErrorText
              });
              softDataCheck = true;
            }
            if (this.question.dataEditChecks[k].type == "GREATER_THAN" && this.question.dataEditChecks[k].value > this.question.answer) {
              fieldErrorText = `This field should be greater than ${this.question.dataEditChecks[k].value}.`;
              toastr.warning(fieldErrorText);

              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: fieldErrorText
              });
              softDataCheck = true;
            }
          } else {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK" && (this.question.answer === "undefined" || this.question.answer === "")) {
              return `This field is required.`;
            } else if (this.question.dataEditChecks[k].type == "GREATER_THAN" && this.question.dataEditChecks[k].value > this.question.answer) {
              return `This field should be greater than ${this.question.dataEditChecks[k].value}.`;
            } else if (this.question.dataEditChecks[k].type == "LESS_THAN" && this.question.dataEditChecks[k].value < this.question.answer) {
              return `This field should be less than ${this.question.dataEditChecks[k].value}.`;
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }

      if (Object.keys(this.question).includes("answer") === false || this.question.answer === undefined || (this.question.constraints && this.question.constraints.formattedLabels && Object.values(this.question.constraints.formattedLabels).includes(this.question.answer) === false)) {
        return this.widget.translate("error_select_answer", "Please select an answer");
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  textResponse() {
    if (this.question) {
      this.question.dataChecks = [];

      if (this.question.dataEditChecks) {
        let fieldErrorText = "";
        let softDataCheck = false;
        const alphanumericRegx = /^[a-zA-Z0-9 ]*$/;
        const numericRegx = /[^a-zA-Z ]+/;
        const alphabetRegx = new RegExp("^[a-zA-Z ]+$");
        for (let k = 0; k < this.question.dataEditChecks.length; k++) {
          if (this.question.dataEditChecks[k].check == "SOFT") {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK" && this.question.answer == "") {
              fieldErrorText = `Your response is requested. Please enter a response.`;
              toastr.warning(fieldErrorText);
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: fieldErrorText
              });

              softDataCheck = true;
            }
            if (this.question.dataEditChecks[k].type == "DATA_TYPE" && this.question.dataEditChecks[k].value == "Alphabet" && !alphabetRegx.test(this.question.answer)) {
              fieldErrorText = `Your response is not in the expected format: Alphabet. Please review your response.`;
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: fieldErrorText
              });
              softDataCheck = true;
            }
            if (this.question.dataEditChecks[k].type == "DATA_TYPE" && this.question.dataEditChecks[k].value == "Numeric" && !numericRegx.test(this.question.answer)) {
              fieldErrorText = `Your response is not in the expected format: Numeric. Please review your response.`;
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: fieldErrorText
              });
              softDataCheck = true;
            }
            if (this.question.dataEditChecks[k].type == "DATA_TYPE" && this.question.dataEditChecks[k].value == "Alphanumeric" && !alphanumericRegx.test(this.question.answer)) {
              fieldErrorText = `Your response is not in the expected format: Alphanumeric. Please review your response.`;
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: fieldErrorText
              });
              softDataCheck = true;
            }
          } else {
            if ((this.question.dataEditChecks[k].type == "NOT_BLANK" && this.question.answer == "") || this.question.answer == undefined) {
              return "Please enter a response.";
            } else if (this.question.dataEditChecks[k].type == "DATA_TYPE" && this.question.dataEditChecks[k].value == "Alphabet" && !alphabetRegx.test(this.question.answer)) {
              return "Please enter a response with format: Alphabet.";
            } else if (this.question.dataEditChecks[k].type == "DATA_TYPE" && this.question.dataEditChecks[k].value == "Alphanumeric" && !alphanumericRegx.test(this.question.answer)) {
              return "Please enter a response with format: Alphanumeric.";
            } else if (this.question.dataEditChecks[k].type == "DATA_TYPE" && this.question.dataEditChecks[k].value == "Numeric" && !numericRegx.test(this.question.answer)) {
              return "Please enter a response with format: Numeric.";
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }

      if (Object.keys(this.question).includes("answer") === false || this.stripHtml(this.question.answer).trim() === "") {
        return this.widget.translate("error_select_answer", "Please select an answer");
      } else if (this.stripHtml(this.question.answer).trim() !== "" && this.question.constraints.characterLimited && this.stripHtml(this.question.answer).trim().length > this.question.constraints.textLimit) {
        return "Character limit should not have to be less then " + this.question.constraints.textLimit;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  vas() {
    if (this.question) {
      this.question.dataChecks = [];
      if (this.question.dataEditChecks) {
        let fieldErrorText = "";
        let softDataCheck = false;
        for (let k = 0; k < this.question.dataEditChecks.length; k++) {
          if (this.question.dataEditChecks[k].check == "SOFT") {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK" && (this.question.answer === "undefined" || this.question.answer === "")) {
              fieldErrorText = `This field prefered to be filled.`;
              toastr.warning(fieldErrorText);

              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: fieldErrorText
              });
              softDataCheck = true;
            }
            if (this.question.dataEditChecks[k].type == "LESS_THAN" && this.question.dataEditChecks[k].value < this.question.answer) {
              fieldErrorText = `This field should be less than ${this.question.dataEditChecks[k].value}.`;
              toastr.warning(fieldErrorText);
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: fieldErrorText
              });
              softDataCheck = true;
            }
            if (this.question.dataEditChecks[k].type == "GREATER_THAN" && this.question.dataEditChecks[k].value > this.question.answer) {
              fieldErrorText = `This field should be greater than ${this.question.dataEditChecks[k].value}.`;
              toastr.warning(fieldErrorText);

              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: fieldErrorText
              });
              softDataCheck = true;
            }
          } else {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK" && (this.question.answer === "undefined" || this.question.answer === "")) {
              return `This field is required.`;
            } else if (this.question.dataEditChecks[k].type == "GREATER_THAN" && this.question.dataEditChecks[k].value > this.question.answer) {
              return `This field should be greater than ${this.question.dataEditChecks[k].value}.`;
            } else if (this.question.dataEditChecks[k].type == "LESS_THAN" && this.question.dataEditChecks[k].value < this.question.answer) {
              return `This field should be less than ${this.question.dataEditChecks[k].value}.`;
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }

      if (this.question.answer === undefined || Object.keys(this.question).includes("answer") === false || (this.question.constraints && this.question.constraints.formattedLabels && Object.values(this.question.constraints.formattedLabels).includes(this.question.answer) === false)) {
        return this.widget.translate("error_select_answer", "Please select an answer");
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  wongBaker() {
    // return true;
    const wongAnswer = ["0", "2", "4", "6", "8", "10"];
    if (this.question) {
      this.question.dataChecks = [];
      if (this.question.dataEditChecks) {
        let fieldErrorText = "";
        let softDataCheck = false;
        for (let k = 0; k < this.question.dataEditChecks.length; k++) {
          if (this.question.dataEditChecks[k].check == "SOFT") {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK" && (this.question.answer === "" || this.question.optionId === "")) {
              fieldErrorText = `This field is required.`;
              toastr.warning(fieldErrorText);
              softDataCheck = true;
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: fieldErrorText
              });
            }
          } else {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK" && (this.question.answer === "" || this.question.optionId === "")) {
              return "This field is required.";
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }
      if (wongAnswer.includes(this.question.answer)) {
        return true;
      }
      if (Object.keys(this.question).includes("answer") === false || this.question.answer === "" || this.question.optionId === "") {
        return this.widget.translate("error_select_answer", "Please select an answer");
      } else if (wongAnswer.includes(this.question.answer) != true) {
        return this.widget.translate("PWEB_ERROR_NUMBER_RESPONSE", "Please select correct answer.");
      } else if (wongAnswer.includes(this.question.answer)) {
        return true;
      }
    } else {
      return false;
    }
  }

  stripHtml(content) {
    const temporalDivElement = document.createElement("div");
    temporalDivElement.innerHTML = content;
    return temporalDivElement.innerText;
  }
}

export class FirebaseApp {
  firebaseConfig = {};
  firebase;
  widget;
  potal;
  currentToken;
  vapidKey = null;

  constructor(config, appId) {
    this.widget = new Widget();
    this.portal = new ParticipantPortal();
    this.firebaseConfig = {
      apiKey: config.apiKey,
      authDomain: config.authDomain,
      projectId: config.projectId,
      storageBucket: config.storageBucket,
      messagingSenderId: config.messagingSenderId,
      appId: appId
    };
    this.vapidKey = config.vapId;

    this.firebase = initializeApp(this.firebaseConfig);
  }

  getMessaging() {
    return getMessaging(this.firebase);
  }

  getMessageHandler() {
    return this.firebase.messaging();
  }

  getToken() {
    const that = this;
    return new Promise((resolve, reject) => {
      getToken(this.getMessaging(), { vapidKey: this.vapidKey })
        .then(function(currentToken) {
          if (currentToken) {
            that.currentToken = currentToken;
            that
              .registerDevice(currentToken)
              .then(res => {
                if ("serviceWorker" in navigator && "PushManager" in window) {
                  navigator.serviceWorker
                    .register("/firebase-messaging-sw.js", {
                      scope: "/#/participants/web/",
                      type: "module"
                    })
                    .then(function() {
                      resolve(res);
                    })
                    .catch(function(err) {
                      reject(err);
                    });
                } else {
                  reject();
                }
              })
              .catch(e => reject(e));
          } else {
            reject(false);
          }
        })
        .catch(function() {
          reject(false);
        });
    });
  }

  registerDevice(token) {
    return new Promise(resolve => {
      const participant = this.portal.getParticipant();
      const registerPayload = {
        id: participant.studyVersionId,
        participantId: participant.pid,
        studyId: participant.studyId,
        pdDeviceToken: token,
        pdDevicePlatform: "Web",
        pdDevicePlatformVersion: "",
        pdDeviceModel: "",
        pdDeviceMake: "",
        pdEndpointArn: "",
        pdRegistrationStatus: true,
        deviceId: this.portal.getDevice(),
        bundleId: "",
        appType: "StudyApp"
      };
      api
        .registerParticipantDevice(registerPayload)
        .then(response => {
          resolve(response);
          localStorageService.setItem("pweb-allow-notification", localStorageService.getItem("pweb-allow-notification") ? localStorageService.getItem("pweb-allow-notification") : false);
        })
        .catch(() => {
          localStorageService.setItem("pweb-allow-notification", localStorageService.getItem("pweb-allow-notification") ? localStorageService.getItem("pweb-allow-notification") : false);
          const message = this.widget.translate("push_enable_text", "Please allow app to receive notifications.");
          toastr.warn(message);
        });
    });
  }
}

export class Participant {
  portal = new ParticipantPortal();
  bitrise = new Bitrise();
  participantDetails = {};

  constructor() {
    this.participantDetails = store.getters.getParticipantDetails;
  }

  formatPhoneNumber(phoneNumberString) {
    const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    const newmatch = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
    if (newmatch) {
      return "(" + newmatch[2] + ") " + newmatch[3] + "-" + newmatch[4];
    }
    return phoneNumberString;
  }

  getParticipantEmail() {
    if (this.portal.isOpenEnrollmentStudy()) {
      return localStorageService.getItem("pw-openEnrollEmail");
    } else if (this.participantDetails && this.participantDetails.email) {
      return this.participantDetails.email;
    }
    return "";
  }

  getParticipantPhoneE164() {
    return this.participantDetails.mobileCountryCode + this.participantDetails.mobile;
  }

  getParticipantActivationToken() {
    if (this.participantDetails && this.participantDetails.activationToken) {
      return this.participantDetails.activationToken;
    }
    return "";
  }

  getSiteData() {
    if (this.participantDetails && this.participantDetails.site) {
      return this.participantDetails.site;
    }
    return "";
  }

  getSiteID() {
    if (this.getSiteData() && this.getSiteData().siteId) {
      return this.getSiteData().siteId;
    }
    return "";
  }

  getParticipantID(token) {
    if (this.participantDetails && this.participantDetails.pid) {
      return this.participantDetails.pid;
    } else if (token) {
      const tokenObj = jwtDecode(token);
      return tokenObj && tokenObj.pId;
    }
    return "";
  }

  get isPhoneVerification() {
    if (this.participantDetails && this.participantDetails.verificationMethod == "phone") {
      return true;
    }
    return false;
  }

  get formattedMobileNumber() {
    if (this.participantDetails && this.participantDetails.mobile && this.participantDetails.mobileCountryCode) {
      const id = this.participantDetails.mobileCountryCode + this.participantDetails.mobile;
      return parsePhoneNumber(id).formatNational();
    } else {
      return null;
    }
  }

  getVerificationPhone() {
    if (this.participantDetails && this.participantDetails.mobile) {
      return this.participantDetails.mobile;
    }
    return null;
  }

  getParticipantIdentity(format = false) {
    return this.isPhoneVerification ? (format ? this.formattedMobileNumber : this.getVerificationPhone()) : this.getParticipantEmail();
  }
}

export class Consent {
  widget = new Widget();
  bitrise = new Bitrise();
  portal = new ParticipantPortal();

  concents = [];
  currentConsentId = null;
  currentConsentObj = null;
  listOfCohart = [];

  constructor() {
    this.currentConsentObj = store.getters.getParticipantPortalConsentData;
  }

  getCurrentConsentId() {
    return this.currentConsentObj && this.currentConsentObj.config && this.currentConsentObj.config.consentId;
  }

  getDocumentAndSignHtml(consentId) {
    if (this.bitrise == null) {
      return;
    }
    if (this.bitrise) {
      return this.bitrise.getAgreementData(consentId);
    } else {
      return new Promise((resolve, reject) => {
        reject("DATA_SYNC_ERROR_MSG");
      });
    }
  }

  getCohartData() {
    return new Promise((resolve, reject) => {
      const cohartData = this.bitrise.getJsonData("cohort");
      if (cohartData) {
        cohartData
          .then(response => {
            this.listOfCohart = response.cohortSort;
            resolve(this.listOfCohart);
          })
          .catch(e => {
            const message = this.widget.translate(e.message, "Data sync failed, please try again after some time.");
            if (message) {
              toastr.error(message);
            }
            reject(false);
          });
      } else {
        reject(false);
      }
    });
  }

  getDataventConsentData() {
    return new Promise((resolve, reject) => {
        let cohartData = this.bitrise.getJsonData("datavant_consent");
        if (cohartData) {
            cohartData.then(response => {                 
               resolve(response);
            }).catch(e => {
                let message = this.widget.translate(e.message, "Data sync failed, please try again after some time.");
                if (message) { toastr.error(message); }
                reject(false);
            });
        } else {
            reject(false);
        }
    });
  }

  getConcents() {
    return new Promise((resolve, reject) => {
      const concentObj = this.bitrise.getJsonData("consent_configuration");
      if (concentObj) {
        concentObj
          .then(response => {
            this.concents = response.consentConfiguration;
            resolve(this.concents);
          })
          .catch(e => {
            const message = this.widget.translate(e.message, "Data sync failed, please try again after some time.");
            if (message) {
              this.$toastr.error(message);
            }
            reject(false);
          });
      } else {
        reject(false);
      }
    });
  }

  getConcentDetails(consent) {
    return new Promise((resolve, reject) => {
      this.currentConsentId = consent.consentId;
      const concentDetailsObj = this.bitrise.getJsonData(this.currentConsentId);
      if (concentDetailsObj) {
        concentDetailsObj
          .then(response => {
            this.currentConsentObj = { config: consent, details: response };
            resolve(this.currentConsentObj);
          })
          .catch(e => {
            const message = this.widget.translate(e.message, "Data sync failed, please try again after some time.");
            if (message) {
              this.$toastr.error(message);
            }
            reject(false);
          });
      } else {
        reject(false);
      }
    });
  }

  getContentSections() {
    if (this.currentConsentObj && this.currentConsentObj.details && this.currentConsentObj.details.sections) {
      return this.currentConsentObj.details.sections;
    }
    return [];
  }

  getConcentQuestions() {
    if (this.currentConsentObj && this.currentConsentObj.details && this.currentConsentObj.details.quiz) {
      return this.currentConsentObj.details.quiz;
    }
    return [];
  }

  getConcentDisclaimers() {
    if (this.currentConsentObj && this.currentConsentObj.details && this.currentConsentObj.details.listOfDisclaimer) {
      return this.currentConsentObj.details.listOfDisclaimer;
    }
    return [];
  }

  i18n(key, lang) {
    if (lang && lang.toLowerCase() !== this.defaultCulture) {
      this.languageCulture = lang;
    }

    if (store.getters.getParticipantsPortalLanguageTranslation || this.allStaticKeys !== null) {
      this.strings = store.getters.getParticipantsPortalLanguageTranslation ? store.getters.getParticipantsPortalLanguageTranslation : this.allStaticKeys;
      return this.strings[key] ? this.strings[key] : false;
    }
    if (this.languageCulture !== "" && this.languageCulture !== undefined && this.languageCulture !== "EN" && this.allApplangaKeys !== null) {
      let entries = this.allStaticKeys[this.languageCulture]["main"]["entries"];
      return entries[key] ? entries[key].v : "";
    }
    return false;
  }
}

export class DatavantTokens{

    tokensList = {
        token1 : "LastName + 1st initial of First Name + Gender + DOB",
        token2 : "LastName  + FirstName  + Gender + DOB",
        token3 : "LastName + FirstName + DOB + Zip3",
        token4 : "LastName + FirstName + Gender + DOB",
        token6 : "Last Name + 1st 3 Characters of First Name + Gender + DOB + ZIP3",
        token7 : "Last Name + 1st 3 Characters of First Name + Gender + DOB",
        token8 : "Last Name + 1st 3 Characters of First Name + Gender + ZIP5",
        token9 : "First Name + Address",
        token12 : "Last Name + First Name + Gender + ZIP5",
        token14 : "Address + ZIP5 + DOB",
        token15 : "Address + ZIP5 + DOB + Gender",
        token17 : "LastName + FirstName + Address + Zip5",
        token18 : "Last Name + First Name + Gender + ZIP5 + Birth Year + Birth Month",
        token23 : "Last Name + 1st Initial of First Name + DOB + ZIP3",
        token24 : "Last Name  + First Name  + DOB + ZIP3",
        token25 : "First Name + Last Name + DOB + Gender + ZIP2",
        token26 : "Last Name + First Name + DOB + ZIP5",
        token29 : "FirstName + Email",
        token30 : "FirstName + CellPhone"
    };

    getSubString(string, char){
        return string.substr(0, char);
    }

    prepareTokensMeta(particiapntData, tokens){
        
        let firstName = particiapntData.participantMeta.firstName;
        let lastName = particiapntData.participantMeta.lastName;
        let gender = particiapntData.participantMeta.gender;
        let dob = particiapntData.participantMeta.dob;
        let [dobYear, dobMonth] = dob.split("-");
        let zip = particiapntData.participantMeta.zipcode;
        let zip2 = this.getSubString(zip, 2);
        let zip3 = this.getSubString(zip, 3);
        let zip5 = this.getSubString(zip, 5);
        let address = particiapntData.participantMeta.address;
        let email = particiapntData.email;
        let phoneNumber = particiapntData.participantMeta.countryCode + particiapntData.participantMeta.phoneNumber;
        let first_initialOf_FirstName = this.getSubString(firstName, 1);//firstName.split(" ")[0];
        let first_3CharOf_FirstName = this.getSubString(firstName, 3);

        for(let i = 0 ; i < tokens.length; i++){
            switch (tokens[i].field) {
                case this.tokensList.token1:
                    tokens[i].value = `${lastName} + ${first_initialOf_FirstName} + ${gender} + ${dob}`;
                    break;
                case this.tokensList.token2:
                case this.tokensList.token4:
                    tokens[i].value = `${lastName} + ${firstName} + ${gender} + ${dob}`;
                    break;
                case this.tokensList.token3:
                case this.tokensList.token24:
                    tokens[i].value = `${lastName} + ${firstName} + ${dob} + ${zip3}`;
                    break;
                case this.tokensList.token17:
                    tokens[i].value = `${lastName} + ${firstName} + ${address} + ${zip5}`;
                    break;
                case this.tokensList.token29:
                    tokens[i].value = `${firstName} + ${email}`;
                    break;
                case this.tokensList.token30:
                    tokens[i].value = `${firstName} + ${phoneNumber}`;
                    break;
                case this.tokensList.token6:
                    tokens[i].value = `${lastName} + ${first_3CharOf_FirstName} + ${gender} + ${dob} + ${zip3}`;
                    break;
                case this.tokensList.token7:
                    tokens[i].value = `${lastName} + ${first_3CharOf_FirstName} + ${gender} + ${dob}`;
                    break;
                case this.tokensList.token8:
                    tokens[i].value = `${lastName} + ${first_3CharOf_FirstName} + ${gender} + ${zip5}`;
                    break;
                case this.tokensList.token9:
                    tokens[i].value = `${firstName} + ${address}`;
                    break;
                case this.tokensList.token12:
                    tokens[i].value = `${lastName} + ${firstName} + ${gender} + ${zip5}`;
                    break;
                case this.tokensList.token14:
                    tokens[i].value = `${address} + ${zip5} + ${dob}`;
                    break;
                case this.tokensList.token15:
                    tokens[i].value = `${address} + ${zip5} + ${dob} + ${gender}`;
                    break;
                case this.tokensList.token18:
                    tokens[i].value = `${lastName} + ${firstName} + ${gender} + ${zip5} + ${dobYear} + ${dobMonth}`;
                    break;
                case this.tokensList.token23:
                    tokens[i].value = `${lastName} + ${first_initialOf_FirstName} + ${dob} + ${zip3}`;
                    break;
                case this.tokensList.token25:
                    tokens[i].value = `${firstName} + ${lastName} + ${dob} + ${gender} + ${zip2}`;
                    break;
                case this.tokensList.token26:
                    tokens[i].value = `${lastName} + ${firstName} + ${dob} + ${zip5}`;
                    break;
            }
        }

        return tokens;

    }

    checkIfFieldPresentInTokens(tokenString, tokens){
        return _.find(tokens, function(t) { 
            return t.field.toLowerCase().includes(tokenString.toLowerCase()); 
        });
    }
}